<script>
import constant from '@constants/constant'
import {
  fraudplusMethod,
  toasterMethods,
  fPlusIntegrationMethods,
  fPlusIntegration,
} from '@state/helpers'
import NoRecordFound from '@/src/components/_norecord-found'
import liensAndJudgment from '@src/components/FraudPlusReport/liensAndJudgments.vue'
import relativeAssociates from '@src/components/FraudPlusReport/relativesAndAssociates.vue'
import employerValidation from '@src/components/FraudPlusReport/employerValidation.vue'
import VoterRegistration from '@/src/components/FraudPlusReport/voterRegistration.vue'
import DriversLicenseSearch from '@/src/components/FraudPlusReport/driversLicenseSearch.vue'
import propertyownership from '@/src/components/FraudPlusReport/propertyownership.vue'
import AssociatedBusinessFunctions from '@/src/components/FraudPlusReport/associatedBusinessFunctions.vue'
import propertyDetails from '@/src/components/FraudPlusReport/propertyDetails.vue'
import BaseFinding from '@/src/components/FraudPlusReport/_base-Finding'
import HousePriceIndexTable from '@/src/components/FraudPlusReport/housePriceIndexTable'
import format from 'date-fns/format'
import CompetitiveMarketClimate from '@/src/components/FraudPlusReport/competitiveMarketClimate.vue'
import ComparablesMatrixTable from '@/src/components/FraudPlusReport/comparablesMatrixTable.vue'
import Avm from '@/src/components/FraudPlusReport/avm.vue'
import MERS from '@/src/components/FraudPlusReport/mers.vue'
// import AppendixWatchlists from '@/src/components/FraudPlusReport/appendixWatchlists.vue'
// import NoTriggerFound from '@/src/components/FraudPlusReport/noTriggerFound.vue'
import RiskIndicators from '@/src/components/FraudPlusReport/riskIndicators.vue'
import FEMADisasterList from '@/src/components/FraudPlusReport/FEMADisasterList.vue'
// import VueHtmlAsPdf from '@/src/components/VueHtmlAsPdf/VueHtmlAsPdf.vue'
import PropertyHistorySearch from '@/src/components/FraudPlusReport/propertyHistorySearch.vue'
import AreaRecentSalesDetails from '@/src/components/FraudPlusReport/areaRecentSalesDetails.vue'
import fPlusConfigMethods from '@src/state/modules/fraudPlusConfigMethods.js'
import { uppercase } from '@/src/utils/filters'
import CustomMessage from '@/src/components/_custom-message.vue'
import common from '@state/modules/common'
import UccFilings from '@/src/components/FraudPlusReport/uccFilings.vue'
import SexualOffences from '@/src/components/FraudPlusReport/sexualOffences.vue'
import CriminalRecords from '@/src/components/FraudPlusReport/criminalRecords.vue'
import Bankruptcy from '@/src/components/FraudPlusReport/bankruptcy.vue'
import ProfessionalLicenses from '@/src/components/FraudPlusReport/professionalLicenses.vue'
import VerificationofOccupancy from '@/src/components/FraudPlusReport/verificationofOccupancy.vue'
import WatchlistDetails from '@/src/components/FraudPlusReport/watchlistDetails.vue'

export default {
  page: {
    title: '',
    meta: [{ name: 'description', content: 'FraudplusReportPage' }],
  },
  components: {
    // VueHtmlAsPdf,
    NoRecordFound,
    CustomMessage,
    liensAndJudgment,
    VoterRegistration,
    relativeAssociates,
    employerValidation,
    DriversLicenseSearch,
    propertyownership,
    AssociatedBusinessFunctions,
    propertyDetails,
    BaseFinding,
    HousePriceIndexTable,
    CompetitiveMarketClimate,
    ComparablesMatrixTable,
    Avm,
    MERS,
    // AppendixWatchlists,
    // NoTriggerFound,
    RiskIndicators,
    FEMADisasterList,
    PropertyHistorySearch,
    AreaRecentSalesDetails,
    SexualOffences,
    CriminalRecords,
    UccFilings,
    Bankruptcy,
    ProfessionalLicenses,
    VerificationofOccupancy,
    WatchlistDetails,
  },
  filters: {
    uppercase,
  },
  data() {
    return {
      fraudXFooterData: constant.FraudXFooterText,
      fraudXHeaderData: constant.FraudXHeaderText,
      isshowAvm: false,
      isshowMERS: false,
      isShowPropertyMERS: false,
      AVMData: {},
      mersResponse: {},
      propertyMersResponse: {},
      showUpdateStatusModal: false,
      showCommentModal: false,
      riskStatus: '',
      borrowerRiskList: [
        { text: 'Caution', value: 'Caution' },
        { text: 'Cleared', value: 'Cleared' },
      ],
      borrowerRiskStatus: '',
      borrowerRiskComment: '',
      borrowerComment: '',
      indexid: 0,
      propertyHistoryData: [],
      propertyFields: [
        'Sale_Date',
        'Buyer',
        'Seller',
        'Sale_price',
        'Loan_Amount',
        'Lender',
        'Document_Type',
        'Recording_Date',
      ],
      propertyHistoryList: [],
      isVisible: true,
      commentsProperty: [],
      isVisibleHistory: false,
      isVisibleDistance: false,
      // isVisibleDBorrower: false,
      isSubjectValuation: false,
      isIprSubjectValuation: false,
      isVisibleParticipant: false,
      isShowNodForeclosure: false,
      isShowBankruptcy: false,
      isShowProfLicenses: false,
      isShowVOOSection: false,
      isShowNmlsColumn: false,
      isShowPepColumn: false,
      isVisibleAreaRecentSales: false,
      isVisibleAreaMarketAnalysis: false,
      isVisibleHpiOverview: false,
      isShowDistanceEstimation: false,
      isVisibleHousePriceIndex: false,
      isVisibleCompMarketClimate: false,
      isVisibleComparablesMatrix: false,
      options: [],
      title: 'FraudPlus Report',
      showSpinner: false,
      dateOfBirthVerificationFields: [
        {
          key: 'dob',
          label: 'Type',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '20%' },
        },
        {
          key: 'dobDate',
          label: 'Value',
          thClass: 'text-right',
          tdClass: 'textTruncatee text-right',
          thStyle: { width: '30%' },
        },
        {
          key: 'Verified',
          label: 'Verified',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '50%' },
        },
      ],
      dateOfBirthVerificationItems: [],
      deceasedRecordsFields: [
        {
          key: 'Record',
          label: 'Type',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '50%' },
        },
        {
          key: 'Data',
          label: 'Value',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '50%' },
        },
      ],
      deceasedRecordsItems: [],
      addressHistoryRecordFields: [
        {
          key: 'Address',
          label: 'Address',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '50%' },
        },
        {
          key: 'PhoneNumber',
          label: 'Phone Number',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '20%' },
        },
        {
          key: 'dateFirstSeen',
          label: 'Date First Seen',
          thClass: 'text-right',
          tdClass: 'textTruncatee text-right',
          thStyle: { width: '10%' },
        },
        {
          key: 'dateLastSeen',
          label: 'Date Last Seen',
          thClass: 'text-right',
          tdClass: 'textTruncatee text-right',
          thStyle: { width: '10%' },
        },
        {
          key: 'bestAddress',
          label: 'Best Address(Y/N)',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '10%' },
        },
      ],
      addressHistoryRecordItems: [],
      personSearchFields: [
        {
          key: 'id',
          label: 'ID',
          thClass: 'text-right',
          class: 'text-right',
        },
        {
          key: 'type',
          label: 'Type',
          thClass: 'text-left',
        },
        {
          key: 'Knownalternatives',
          label: 'Known Alternatives/Alias',
          thClass: 'text-left',
        },
        {
          key: 'residenceaddress',
          label: 'Residence Address',
          thClass: 'text-left',
        },
        {
          key: 'datefirstseen',
          label: 'Date First Seen',
          thClass: 'text-right',
          class: 'text-right',
        },
        {
          key: 'datelastseen',
          label: 'Date Last Seen',
          thClass: 'text-right',
          class: 'text-right',
        },
      ],
      personSearchItems: [],
      // confidenceLevel: [],
      nameAddressFields: [
        {
          key: 'attribute',
          label: 'Type',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '250px' },
        },
        {
          key: 'value',
          label: 'Value ',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '100%-300px' },
        },
        {
          key: 'isVerified',
          label: 'Verified',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '300px' },
        },
      ],
      relativesAndAssociates: [],
      addressModalList: [],
      nameAddressItems: [],
      satusDescription: '',
      commentDescription: '',
      isShowBorrower: false,
      isShowBorrowerAndEmployerWatchlist: false,
      isShowProperty: false,
      isShowPersonSearch: false,
      isShowEmployer: false,
      isShowLiens: false,
      isShowPropertyHistory: false,
      isShowRelatives: false,
      isShowDriversInfo: false,
      isShowVoter: false,
      ispropertyOwnership: false,
      isShowAccociatedBusiness: false,
      isShowParticipantReport: false,
      isShowSubjectValuation: false,
      isShowIprSubjectValuation: false,
      isShowAreaRecentSales: false,
      isShowHousePriceIndex: false,
      housePriceIndexData: {},
      // hpierrorMessage: '',
      hpiPercentileValues: {},
      displayHpiSection: false,
      noHpiData: false,
      displaySubValuation: false,
      displayIprSubValuation: false,
      displayIprReport: false,
      showIprSection: false,
      arsSummaryData: {},
      comparablesMatrixImage: null,
      hpiOverviewImage: null,
      totalPropertyCount: '',
      propertySalesCount: '',
      percentNonOwnerOccupied: '',
      comparablesMatrixData: [],
      areaRecentGraph: '',
      arsErrorMessage: '',
      showARSData: false,
      dataRetrived: 1,
      isBatchOrder: false,
      sirNameVariantsFields: [
        {
          key: 'type',
          label: 'Type',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '50%' },
        },
        {
          key: 'surnameKnown',
          label: 'Value',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '50%' },
        },
      ],
      sirNameVariantsItems: [],
      usingAddressFields: [
        {
          key: 'record',
          label: 'Type',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '50%' },
        },
        {
          key: 'data',
          label: 'Value',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '50%' },
        },
      ],
      usingAddressItems: [],
      ssnValidateFields: [
        {
          key: 'attribute',
          label: 'Type',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '250px' },
        },
        {
          key: 'value',
          label: 'Value ',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '100%-300px' },
        },
        {
          key: 'isValid',
          label: 'Valid',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '300px' },
        },
      ],
      ssnValidateItems: [],
      // dataSource: [],
      namePhoneFields: [
        {
          key: 'attribute',
          label: 'Type',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '250px' },
        },
        {
          key: 'value',
          label: 'Value',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '100%-300px' },
        },
        {
          key: 'isVerified',
          label: 'Verified',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '300px' },
        },
      ],
      namePhoneItems: [],
      dataLookupFields: [
        {
          key: 'record',
          label: 'Type',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '50%' },
        },
        {
          key: 'data',
          label: 'Value',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '50%' },
        },
      ],
      dataLookupItems: [],
      SubjectValuationFields: [
        {
          key: 'value',
          label: 'Estimated Value',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'lvalue',
          label: 'Low Value',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'hvalue',
          label: 'High Value',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'score',
          label: 'Confidence Score',
          class: 'text-right',
          thStyle: { textAlign: 'right' },
        },
        {
          key: 'maxvalue',
          label: 'Max Inherent Financial Risk',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'chvalue',
          label: 'Estimated Value Change - Previous Year',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'nextvalue',
          label: 'Estimated Value Change - Next Quarter',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'avgvalue',
          label: 'Neighborhood Average Price',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
      ],
      iprSubjectValuationFields: [
        {
          key: 'value',
          label: 'Estimated Value',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'lvalue',
          label: 'Low Value',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'hvalue',
          label: 'High Value',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'score',
          label: 'Confidence Score',
          class: 'text-right',
          thStyle: { textAlign: 'right' },
        },
        {
          key: 'chvalue',
          label: 'Estimated Value Change - Previous Year',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'nextvalue',
          label: 'Estimated Value Change - Next Quarter',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
      ],
      SubjectValuationItems: [],
      iprSubjectValuationItems: [],
      subjectValuationAddress: '',
      iprSubjectValuationAddress: '',
      subjectValuationCoordinates: '',
      iprSubjectValuationCoordinates: '',
      distanceEstimationFields: [
        {
          key: 'borrower',
          label: 'Routes Distance Est. (in miles)',
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '30%' },
        },
        {
          key: 'residence',
          label: "Applicant's Residence to Subject Property",
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '35%' },
        },
        {
          key: 'employment',
          label: "Applicant's Employment to Subject Property",
          thClass: 'text-left',
          tdClass: 'textTruncatee',
          thStyle: { width: '35%' },
        },
      ],
      googleDistanceData: [],
      propertyFinding: '',
      loanInformationItems: [
        { fieldName: 'Name', value: '' },
        { fieldName: 'Credit Order ID', value: '' },
        { fieldName: 'SSN', value: '' },
        { fieldName: 'Address', value: '' },
        { fieldName: 'DOB', value: '' },
        { fieldName: 'Phone Number', value: '' },
        { fieldName: "Driver's License", value: '' },
        { fieldName: 'Employer 1 Status', value: '' },
        { fieldName: 'Employer 1 Name', value: '' },
        { fieldName: 'Employer 1 Address', value: '' },
        { fieldName: 'Employer 1 Phone', value: '' },
        { fieldName: 'Employer 2 Status', value: '' },
        { fieldName: 'Employer 2 Name', value: '' },
        { fieldName: 'Employer 2 Address', value: '' },
        { fieldName: 'Employer 2 Phone', value: '' },
      ],
      employerDataKeys: ['employmentStatus1','employerName1','employerAddress1','employerPhone1','employmentStatus2','employerName2','employerAddress2','employerPhone2'],
      employerDefaultKeys: ['employmentStatus','employerName','employmentStreetAddress','employmentPhone'],
      finalReportObj: {},
      followupFields: [
        {
          key: 'attribute',
          label: '',
        },
        {
          key: 'value',
          label: '',
        },
      ],
      reportNumber: '',
      orderBy: '',
      customerName: '',
      referenceNumber: '',
      lastDateModified: '',
      customerAddress: '',
      primaryborrowerName: '',
      dateOrdered: '',
      customerNumber: '',
      integrationUser: '',
      participantreportItems: {},
      loanpropertyAddress: '',
      voterObject: [],
      liensAndJudgementsData: [],
      employerValidationData: [],
      validateRecordTypes: [1, 2, 3],
      driversLicenseData: [],
      propertyOwnershipData: [],
      asscociatedBusinessData: [],
      summaryFindings: [],
      nodForeclosureModelData: [],
      participantItems: [],
      borrowersAndEmployersItems: [],
      participantRiskItems: [],
      borrowersAndEmployersRiskItems: [],
      licenseVerificationsItems: [],
      licenseVerificationsFields: [
        {
          key: 'Name',
          label: 'Participant',
          thClass: 'align-middle',
          tdClass: ['textTruncatee', 'align-middle'],
          thStyle: { width: '15%' },
        },
        {
          key: 'asc',
          label: 'ASC',
          thClass: ['text-center', 'align-middle'],
          thStyle: { width: '8%' },
          tdClass: ['text-center', 'align-middle'],
        },
        {
          key: 'nmls',
          label: 'NMLS',
          thClass: ['text-center', 'align-middle'],
          thStyle: { width: '8%' },
          tdClass: ['text-center', 'align-middle'],
        },
        {
          key: 'Entitytype',
          label: 'Entity Type',
          thClass: 'align-middle',
          thStyle: { width: '8%' },
          tdClass: 'align-middle',
        },
        {
          key: 'LicenseNumber',
          label: 'License Number',
          thClass: 'align-middle',
          thStyle: { width: '16%' },
          tdClass: 'align-middle',
        },
        {
          key: 'Result',
          label: 'Verification Result',
          thClass: 'align-middle',
          thStyle: { width: '45%' },
          tdClass: 'align-middle',
        },
      ],
      licenseTableItems: [
        'nmls',
        'asc'
      ],
      resultFields: [
        // {
        //   key: 'action',
        //   label: '',
        //   thStyle: { textAlign: 'left', width: '10px' },
        //   tdClass: 'textTruncatee',
        // },
        {
          key: 'Name',
          label: 'Participant Name',
          thStyle: { textAlign: 'left', width: '20%' },
          tdClass: 'textTruncatee',
        },
        {
          key: 'Entitytype',
          label: 'Entity Type',
          thStyle: { textAlign: 'left', width: '10%' },
          tdClass: 'textTruncatee',
        },
        {
          key: 'Watchlist',
          label: 'Watchlist Match',
          thStyle: { textAlign: 'left', width: '20%' },
          tdClass: 'textTruncatee',
        },
        // { key: 'SubmittedDetails', label: 'Submitted Details', thStyle: { textAlign: 'right',width: '100px' }, tdClass: 'textTruncatee' },
        {
          key: 'SearchResults',
          label: 'Details',
          thStyle: { textAlign: 'left', width: '50%' },
          tdClass: 'textTruncatee',
        },
      ],
      participantResultItems: [],
      borrowersAndEmployersResultItems: [],
      areaRecentSalesFields: [
        {
          key: 'slno',
          label: '',
        },
        {
          key: 'address',
          label: 'Address',
          thStyle: { width: '300px' },
          tdClass: 'textTruncatee',
          class: 'text-left',
          sortable: true,
        },
        {
          key: 'distance',
          label: 'Dist (miles)',
          thStyle: { width: '50px' },
          tdClass: 'textTruncatee',
          class: 'text-right',
          sortable: true,
        },
        {
          key: 'lastSalePrice',
          label: 'Last Sale Price',
          class: 'text-left',
          sortable: true,
        },
        {
          key: 'lastSaleDate',
          label: 'Last Sale Date',
          class: 'text-right',
          sortable: true,
        },
        {
          key: 'mainSqft',
          label: 'Main Sqft',
          class: 'text-right',
          sortable: true,
        },
        {
          key: 'lotSize',
          label: 'Lot Size(acres)',
          class: 'text-right',
          sortable: true,
        },
        {
          key: 'beds',
          label: 'Beds',
          class: 'text-right',
          sortable: true,
        },
        {
          key: 'bath',
          label: 'Bath',
          class: 'text-right',
          sortable: true,
        },
        {
          key: 'yearBuilt',
          label: 'Year Built',
          class: 'text-right',
          sortable: true,
        },
        {
          key: 'propStyle',
          label: 'Prop Style',
          sortable: true,
        },
        {
          key: 'reo',
          label: 'REO',
          sortable: true,
        },
      ],
      areaRecentSalesItems: [],
      areaMarketAnalysisFields: [
        {
          key: 'indexCol',
          label: '',
          class: 'text-left font-weight-bold',
        },
        {
          key: 'salePrice',
          label: 'Sale Price',
          class: 'text-left',
        },
        {
          key: 'mainSqft',
          label: 'Main Sq Ft',
          class: 'text-right',
        },
        {
          key: 'yearBuilt',
          label: 'Year Built',
          class: 'text-right',
        },
        {
          key: 'lotArea',
          label: 'Lot Area (acres)',
          class: 'text-right',
        },
        {
          key: 'pricePerSqft',
          label: 'Price per Sq Ft',
          class: 'text-left',
        },
        {
          key: 'bedrooms',
          label: 'Bedrooms',
          class: 'text-right',
        },
        {
          key: 'bathrooms',
          label: 'Bathrooms',
          class: 'text-right',
        },
        {
          key: 'bsmntFinished',
          label: 'Bsmnt Finished (Sq Ft)',
          class: 'text-right',
        },
      ],
      areaMarketAnalysisItems: [],
      cmcSegmentResponseModel: [],
      cmcZipCodeResponseModel: [],
      isshowCompetitiveMarket: false,
      displayCmcSection: false,
      // cmcErrorMessage: '',
      cmcZipVal: '',
      AscWatchlist: 'ASC',
      PepWatchlist: 'PEP',
      MrbWatchlist: 'MRB',
      NmlsWatchlist: 'NMLS',
      // isShowBorrowerWatchlist: false,
      // borrowerResultFields: [
      //   {
      //     key: 'action',
      //     label: '',
      //     thStyle: { textAlign: 'left', width: '10px' },
      //     tdClass: 'textTruncatee',
      //   },
      //   {
      //     key: 'Name',
      //     label: 'Name',
      //     thStyle: { textAlign: 'left', width: '80px' },
      //     tdClass: 'textTruncatee',
      //   },
      //   {
      //     key: 'Entitytype',
      //     label: 'Entity Type',
      //     thStyle: { textAlign: 'left', width: '50px' },
      //     tdClass: 'textTruncatee',
      //   },
      //   {
      //     key: 'Watchlist',
      //     label: 'Watchlist',
      //     thStyle: { textAlign: 'left', width: '100px' },
      //     tdClass: 'textTruncatee',
      //   },
      //   // { key: 'SubmittedDetails', label: 'Submitted Details', thStyle: { textAlign: 'right',width: '100px' }, tdClass: 'textTruncatee' },
      //   {
      //     key: 'SearchResults',
      //     label: 'Search Results',
      //     thStyle: { textAlign: 'left', width: '150px' },
      //     tdClass: 'textTruncatee',
      //   },
      // ],
      // borowerResultItems: [],
      // participantApiSuccess: false,
      // borrowerApiSuccess: [],
      propertyRiskItems: [],
      propertyRiskModel: {},
      femaItems: [],
      isShowFEMA: false,
      propertyPHSData: {},
      borrowerPHSData: [],
      isshowPropertyPHSData: false,
      borrowerArray: [],
      isPropertyCollapsed: false,
      isParticipantReportCollapsed: false,
      isBorrowerAndEmployerWatchlistCollapsed: false,
      FraudXHpiText: constant.FraudXHpiText,
      hpiBaseScore: 0,
      hpiScoreLimit: 5,
      arsDetails: {},
      loanFields: [
        {
          key: 'indexCol',
          label: 'Borrower Details',
          class: 'text-left',
          thStyle: { textAlign: 'left', width: '16.5%' },
          tdClass: 'textTruncatee',
        },
      ],
      loanItems: [],
      borrowerKeys: [
        'borrower1',
        'borrower2',
        'borrower3',
        'borrower4',
        'borrower5',
      ],
      loanInfoKeys: [
        'name',
        'creditOrderId',
        'ssn',
        'address',
        'dob',
        'phoneNumber',
        'driverLicence',
        'employmentStatus1',
        'employerName1',
        'employerAddress1',
        'employerPhone1',
        'employmentStatus2',
        'employerName2',
        'employerAddress2',
        'employerPhone2',
      ],
      isClearedStatus: false,
      customError: [],
      borrowerAndEmployerError: null,
      participantError: null,
      propertyErrorMsg:{},
      summaryFindingsErrors: {},
      sexualOffenceDetails: [],
      isShowSODetails: false,
      isShowUCCDetails: false,
      isShowCriminalRecords: false,
      criminalData: [],
      uccDetails: [],
      avmCustomMessage: null,
      bridgerError: null,
      ascError: null,
      bankruptcyData: [],
      profLicensesDetails: [],
      verificationOccupancyDetails: [],
      vooScore: [],
      isReadOnly: false,
    }
  },

  computed: {
      filteredLicenseVerificationsFields() {
        return this.licenseVerificationsFields.filter(field => {
          if (field.key === 'nmls') {
            return this.isShowNmlsColumn;
          }
          return true;
        });
      },
    currentDateTime() {
      return new Date()
        .toLocaleString('en-US', { timeZone: 'America/New_York' })
        .replace(',', '')
    },
    showBorrowerSection() {
      return (
        this.isShowBorrower ||
        this.isShowPropertyHistory ||
        this.isShowLiens ||
        this.isShowPersonSearch ||
        this.isShowEmployer ||
        this.isShowRelatives ||
        this.isShowVoter ||
        this.isShowDriversInfo ||
        this.ispropertyOwnership ||
        this.isShowAccociatedBusiness ||
        this.isShowNodForeclosure ||
        this.isShowBankruptcy ||
        this.isShowProfLicenses ||
        this.isShowVOOSection ||
        // this.isShowBorrowerWatchlist ||
        this.isshowMERS ||
        this.isShowSODetails ||
        this.isShowCriminalRecords ||
        this.isShowUCCDetails
      )
    },
    // isShowAppendix() {
    //   return (
    //     this.isShowBorrowerWatchlist ||
    //     this.AscWatchlistCount
    //   )
    // },
    showPropertySection() {
      return !!(
        this.loanpropertyAddress ||
        this.isShowProperty ||
        this.isshowPropertyPHSData ||
        this.isShowDistanceEstimation ||
        this.isShowSubjectValuation ||
        this.isShowIprSubjectValuation ||
        this.isShowAreaRecentSales ||
        this.isShowHousePriceIndex ||
        this.isshowCompetitiveMarket ||
        this.isshowAvm ||
        this.isShowFEMA ||
        this.isShowPropertyMERS
      )
    },
    showBorrowerAndEmployerDetails() {
      return this.isShowBorrowerAndEmployerWatchlist
    },
    showParticipantDetails() {
      return this.isShowParticipantReport
    },
    femaData() {
      return this.femaItems
    },
    TOKEN() {
      return this.$route.params.Token || null
    },
    ORDER_ID() {
      return this.$route.params.orderId
    },
    User_Name() {
      return this.TOKEN ? this.integrationUser : this.$_userFullName
    },
    access_token() {
      return this.$store.state.auth.currentUser
        ? this.$store.state.auth.currentUser.access_token || null
        : null
    },
  },
  created() {
    if (this.TOKEN) {
      this.setToken(this.TOKEN)
    }
    if (this.access_token || this.TOKEN) {
      this.getFinalReport()
    }
  },
  methods: {
    ...fraudplusMethod,
    ...toasterMethods,
    ...fPlusIntegrationMethods,
    ...fPlusConfigMethods,
    ...fPlusIntegration,

    printReport() {
      window.print()
    },
    // isVerifiedInfoPresent(index) {
    //   return (this.nameAddressItems[index].length || this.ssnValidateItems[index].length || this.namePhoneItems[index].length ||
    //          this.dataLookupItems[index].length || this.usingAddressItems[index].length || this.sirNameVariantsItems[index].length ||
    //          this.dateOfBirthVerificationItems[index].length || this.deceasedRecordsItems[index].length || this.addressHistoryRecordItems[index].length)
    // },
    getFinalReport() {
      this.showSpinner = true
      this.getFPlusReportData(this.ORDER_ID, this.TOKEN).then((resp) => {
        if (resp && resp.status === 200) {
          this.finalReportObj = resp.data
          this.isShowPepColumn = this.finalReportObj.packageInformation &&
            this.finalReportObj.packageInformation.isPepEnabled === true
          this.isShowNmlsColumn = this.finalReportObj.packageInformation &&
            this.finalReportObj.packageInformation.isNmlsEnabled === true
          this.isBatchOrder = this.finalReportObj.reportInformation.batchOrder

          if (this.finalReportObj.participantDetailsModel) {
            if (
              this.validateRecordTypes.includes(
                this.finalReportObj.participantDetailsModel.recordType
              )
            ) {
              // this.participantApiSuccess = this.finalReportObj.participantDetailsModel.isApiSuccess
              this.participantreportItems = this.finalReportObj.participantDetailsModel
            }
          }

          if (this.finalReportObj.remarksComments) {
            this.commentsProperty = this.finalReportObj.remarksComments
          }
          this.loanpropertyAddress = this.finalReportObj.loanInformations[0].propertyAddress
          this.reportNumber = this.finalReportObj.reportInformation.reportNumber
          this.orderBy = this.finalReportObj.reportInformation.orderBy
          this.customerName = this.finalReportObj.reportInformation.customerName
          this.referenceNumber = this.finalReportObj.reportInformation.referenceNumber
          this.lastDateModified = this.finalReportObj.reportInformation.lastDateModified
          this.customerAddress = this.finalReportObj.reportInformation.customerAddress
          this.primaryborrowerName = this.finalReportObj.reportInformation.borrowerName ? this.finalReportObj.reportInformation.borrowerName.trim() || null :  null
          this.dateOrdered = this.finalReportObj.reportInformation.dateOrdered.replace(
            'T',
            ' '
          )
          this.customerNumber = this.finalReportObj.reportInformation.customerNumber
          this.integrationUser = this.finalReportObj.reportInformation.currentUser
          this.isReadOnly = this.finalReportObj.reportInformation.readOnly
          if (this.finalReportObj.propertyHistorySearchForProperty !== null) {
            this.isshowPropertyPHSData = this.validateRecordTypes.includes(
              this.finalReportObj.propertyHistorySearchForProperty.recordType
            )
            if (this.isshowPropertyPHSData) {
              // this.isShowProperty = true
              this.propertyPHSData = {
                phsData: this.finalReportObj.propertyHistorySearchForProperty
                  .propertyHistoryPackage,
              }
            }
          }
          this.loadBorrowerData()
          if (this.finalReportObj.distanceEstimation && this.finalReportObj.distanceEstimation !== null) {
            // this.isShowProperty = true
            this.isShowDistanceEstimation = true
            this.propertyFinding = this.loanpropertyAddress
            let distEstimationData =
              this.finalReportObj.distanceEstimation || []
            let distanceEstimationItems = []
            this.finalReportObj.loanInformations.map((item, index) => {
              distanceEstimationItems[index] = this.filterBorrowerData(
                distEstimationData,
                index
              ).map((ele) => {
                return {
                  name: item.name,
                  borrower: ele.routesDistance,
                  residence: ele.residenceToProperty,
                  employment: ele.employmentToProperty,
                }
              })
            })
            this.googleDistanceData = this.finalReportObj.loanInformations.map(
              (item, ind) => {
                return {
                  distanceEstimationItems: distanceEstimationItems[ind],
                  borrowerName: item.name,
                  isVisibleDistance: false,
                  isVisibleDBorrower: false,
                }
              }
            )
          }
          if (this.finalReportObj.aprResponseModel && this.finalReportObj.aprResponseModel !== null) {
            // this.propertyFinding = this.finalReportObj.aprResponseModel.propertyAddress
            this.isShowSubjectValuation = this.validateRecordTypes.includes(
              this.finalReportObj.aprResponseModel.recordType
            )
            if(this.isShowSubjectValuation) {
              // this.isShowProperty = this.isShowSubjectValuation
            if (this.finalReportObj.aprResponseModel.message !== null) {
              let item = this.finalReportObj.aprResponseModel
              this.SubjectValuationItems = []
              if (item.message && item.message.toLowerCase() === 'success') {
                this.displaySubValuation = true
              }
              this.SubjectValuationItems.push({
                value: this.formatDisplay(item.estimatedValue),
                lvalue: this.formatDisplay(item.lowValue),
                hvalue: this.formatDisplay(item.highValue),
                score: this.formatDisplay(item.confidenceScore),
                maxvalue: this.formatDisplay(item.maxInherentFinancialRisk),
                chvalue: this.formatDisplay(item.estValueChangePrevYr),
                nextvalue: this.formatDisplay(item.estValueChangeNxtYr),
                avgvalue: this.formatDisplay(item.neighbourhoodAvgPrice),
              })
              this.subjectValuationAddress = item.propertyAddress
              this.propertyFinding = item.propertyAddress
              this.subjectValuationCoordinates =
                ' ( Latitude: ' +
                item.lattitude +
                ' , Longitude: ' +
                item.longitude +
                ')'
            }
            }
          }
          if (this.finalReportObj.iprModel && this.finalReportObj.iprModel !== null) {
            this.isShowIprSubjectValuation = this.validateRecordTypes.includes(
              this.finalReportObj.iprModel.recordType
            )
            if(this.isShowIprSubjectValuation) {
              this.displayIprReport = this.isShowIprSubjectValuation
              // this.isShowProperty = this.isShowIprSubjectValuation
            if(this.finalReportObj.iprModel.iprResponseModel !== null) {
            if (
              this.finalReportObj.iprModel.iprResponseModel.message !== null
            ) {
              let item = this.finalReportObj.iprModel.iprResponseModel
              this.iprSubjectValuationItems = []
              if (item.message && item.message.toLowerCase() === 'success') {
                this.displayIprSubValuation = true
                this.showIprSection = true
              }
              this.iprSubjectValuationItems.push({
                value: this.formatDisplay(item.estimatedValue),
                lvalue: this.formatDisplay(item.lowValue),
                hvalue: this.formatDisplay(item.highValue),
                score: this.formatDisplay(item.confidenceScore),
                chvalue: this.formatDisplay(item.estValueChangePrevYr),
                nextvalue: this.formatDisplay(item.estValueChangeNxtYr),
              })
              this.iprSubjectValuationAddress = item.propertyAddress
              this.propertyFinding = item.propertyAddress
              this.iprSubjectValuationCoordinates =
                ' ( Latitude: ' +
                item.lattitude +
                ' , Longitude: ' +
                item.longitude +
                ')'
              if (
                this.finalReportObj.iprModel.areaMarketAnalysisResponseModel !==
                null
              ) {
                var marketData = this.finalReportObj.iprModel
                  .areaMarketAnalysisResponseModel
                this.totalPropertyCount = marketData.totalPropertyCount
                this.propertySalesCount = marketData.propertySalesCount
                this.percentNonOwnerOccupied =
                  marketData.percentNonOwnerOccupied
              }
              if (
                this.finalReportObj.iprModel.subjectPriceResponseModel !== null
              ) {
                this.areaMarketAnalysisItems = (
                  this.finalReportObj.iprModel.subjectPriceResponseModel || []
                ).map((item) => {
                  return {
                    indexCol: this.formatDisplay(item.type),
                    salePrice: this.formatDisplay(item.salePrice),
                    mainSqft: this.formatDisplay(item.mainSqFt),
                    yearBuilt: this.formatDisplay(item.yearBuilt),
                    lotArea: this.formatDisplay(item.lotArea),
                    pricePerSqft: this.formatDisplay(item.pricePerSqFt),
                    bedrooms: this.formatDisplay(item.bedrooms),
                    bathrooms: this.formatDisplay(item.bathrooms),
                    bsmntFinished: this.formatDisplay(item.basementFinished),
                  }
                })
              }
              this.hpiOverviewImage = this.finalReportObj.iprModel.hpiByteArray
              this.comparablesMatrixImage = this.finalReportObj.iprModel.byteArray
              if (
                this.finalReportObj.iprModel.comparableMatrixResponseModel
                  .length
              ) {
                this.comparablesMatrixData = this.finalReportObj.iprModel.comparableMatrixResponseModel
              }
            }
           }
          }
          }
          if (this.finalReportObj.arsResponseModel && this.finalReportObj.arsResponseModel !== null) {
            this.propertyFinding = this.loanpropertyAddress
            this.isShowAreaRecentSales = this.validateRecordTypes.includes(
              this.finalReportObj.arsResponseModel.recordType
            )
            if(this.isShowAreaRecentSales) {
            if (
              this.finalReportObj.arsResponseModel.arsHeaderResponseModel !==
              null
            ) {
              // this.isShowProperty = true
              this.arsSummaryData = this.finalReportObj.arsResponseModel.arsHeaderResponseModel
              this.areaRecentGraph = this.finalReportObj.arsResponseModel.byteArray
            }
            if (
              this.finalReportObj.arsResponseModel
                .arsSubjectPropertyResponseModel !== null
            ) {
              this.arsErrorMessage = this.finalReportObj.arsResponseModel
                .arsSubjectPropertyResponseModel.length
                ? this.finalReportObj.arsResponseModel
                    .arsSubjectPropertyResponseModel[0].message
                : null
              if (
                this.finalReportObj.arsResponseModel
                  .arsSubjectPropertyResponseModel &&
                this.finalReportObj.arsResponseModel
                  .arsSubjectPropertyResponseModel.length
              ) {
                this.showARSData = true
              }
              this.areaRecentSalesItems = (
                this.finalReportObj.arsResponseModel
                  .arsSubjectPropertyResponseModel || []
              ).map((item) => {
                return {
                  slno: this.formatDisplay(item.property),
                  address: this.formatDisplay(item.address),
                  distance: this.formatDisplay(item.distance),
                  lastSalePrice: this.formatDisplay(item.lastSalePrice),
                  lastSaleDate: this.formatDisplay(item.lastSaleDate),
                  mainSqft: this.formatDisplay(item.mainSqFt),
                  lotSize: this.formatDisplay(item.lotSize),
                  beds: this.formatDisplay(item.beds),
                  bath: this.formatDisplay(item.bath),
                  yearBuilt: this.formatDisplay(item.yearBuilt),
                  propStyle: this.formatDisplay(item.propStyle),
                  reo: this.formatDisplay(item.reo),
                }
              })
            }
            let arsSaleTransfersData = []
            arsSaleTransfersData = (
              this.finalReportObj.arsResponseModel
                .arsSaleTransfersResponseModel || []
            ).map((item) => {
              return {
                saleDate: this.formatDisplay(item.saleDate),
                salePrice: this.formatDisplay(item.salePrice),
                transferType: this.formatDisplay(item.transferType),
                perChangePrice:
                  item.pctPriceChangeFromPriorSaleNominal ||
                  item.pctPriceChangeFromPriorSaleAnnualized
                    ? `${this.formatDisplay(
                        item.pctPriceChangeFromPriorSaleNominal
                      )} / ${this.formatDisplay(
                        item.pctPriceChangeFromPriorSaleAnnualized
                      )}`
                    : '',
                perChangeHpi: this.formatDisplay(
                  item.pctHPIChangeFromPriorSale
                ),
                sqftAmount: this.formatDisplay(item.pricePerSquareFoot),
                buyerSeller:
                  item.buyer || item.seller
                    ? `${this.formatDisplay(item.buyer)} / ${this.formatDisplay(
                        item.seller
                      )}`
                    : '',
              }
            })
            this.arsDetails = {
              arsData:
                this.finalReportObj.arsResponseModel.arsDetailsResponseModel ||
                null,
              arsSaleTransfersData: arsSaleTransfersData || [],
            }
          }
          }
          if (this.finalReportObj.hpiResponseModel && this.finalReportObj.hpiResponseModel !== null) {
            this.propertyFinding = this.loanpropertyAddress
            this.isShowHousePriceIndex = this.validateRecordTypes.includes(
              this.finalReportObj.hpiResponseModel.recordType
            )
            if(this.isShowHousePriceIndex) {
            this.noHpiData =
              this.finalReportObj.hpiResponseModel.recordType !== 2
            if (
              this.finalReportObj.hpiResponseModel.hpiDataResponseModel &&
              this.finalReportObj.hpiResponseModel.hpiDataResponseModel.length
            ) {
              // this.isShowProperty = true
              let item = this.finalReportObj.hpiResponseModel
                .hpiDataResponseModel[0]
              if (item.message && item.message.toLowerCase() === 'success') {
                this.displayHpiSection = true
                this.housePriceIndexData = this.finalReportObj.hpiResponseModel
              }
              let pctValues =
                this.finalReportObj.hpiResponseModel
                  .hpiPctChangeResponseModel || null
              this.hpiPercentileValues = {
                quarterPercentile: pctValues
                  ? pctValues.quarterPercentile || ''
                  : '',
                yearPercentile: pctValues ? pctValues.yearPercentile || '' : '',
              }
              // this.hpierrorMessage = item.message ? item.message : null
            }
            }
          }
          if (this.finalReportObj.cmcResponseModel && this.finalReportObj.cmcResponseModel !== null) {
            this.isshowCompetitiveMarket = this.validateRecordTypes.includes(
              this.finalReportObj.cmcResponseModel.recordType
            )
            if(this.isshowCompetitiveMarket) {
            if (
              this.finalReportObj.cmcResponseModel.cmcSegmentResponseModel &&
              this.finalReportObj.cmcResponseModel.cmcSegmentResponseModel
                .length
            ) {
              // this.isShowProperty = true
              let item = this.finalReportObj.cmcResponseModel
                .cmcSegmentResponseModel[0]
              this.propertyFinding = this.loanpropertyAddress
              if (item.message && item.message.toLowerCase() === 'success') {
                this.displayCmcSection = true
                this.cmcSegmentResponseModel = this.finalReportObj.cmcResponseModel.cmcSegmentResponseModel
                let cmcZip = item.propertyAddress
                  ? item.propertyAddress.split(' ')
                  : ''
                this.cmcZipVal = cmcZip ? cmcZip[cmcZip.length - 1] : ''
              }
              // this.cmcErrorMessage = item.message ? item.message : null
            }
            if (
              this.finalReportObj.cmcResponseModel.cmcZipCodeResponseModel &&
              this.finalReportObj.cmcResponseModel.cmcZipCodeResponseModel
                .length
            ) {
              this.cmcZipCodeResponseModel = this.finalReportObj.cmcResponseModel.cmcZipCodeResponseModel
            }
            }
          }
          if (this.finalReportObj.avmReportResponse && this.finalReportObj.avmReportResponse !== null) {
            this.isshowAvm = this.validateRecordTypes.includes(
              this.finalReportObj.avmReportResponse.recordType
            )
            if (this.isshowAvm) {
              // this.isShowProperty = true
              this.AVMData = this.finalReportObj.avmReportResponse
              this.avmCustomMessage = this.AVMData.validMessage ? this.AVMData.validMessage.trim() ? this.AVMData.validMessage : null : null
            }

          }
          if (this.finalReportObj.femaReportResponse && this.finalReportObj.femaReportResponse !== null) {
            this.isShowFEMA = this.validateRecordTypes.includes(
              this.finalReportObj.femaReportResponse.recordType
            )
            if (this.isShowFEMA) {
              // this.isShowProperty = true
              this.femaItems =
                this.finalReportObj.femaReportResponse
                  .femaReportResponseDetails || []
            }
          }
          if (this.finalReportObj.mersPropertyReportResponse !== null) {
            this.isShowPropertyMERS = this.validateRecordTypes.includes(
              this.finalReportObj.mersPropertyReportResponse.recordType
            )
            if (this.isShowPropertyMERS) {
              // this.isShowProperty = true
              this.propertyMersResponse = {
                mersResponse: this.finalReportObj.mersPropertyReportResponse
                  .mersPropertyReportResponseDetails,
                address: this.loanpropertyAddress,
              }
            }
          }
          // Property risk indicators
          let propertyRiskIndicators =
            this.finalReportObj.propertyRiskIndicators || []
          if (propertyRiskIndicators.length > 0) {
            this.isShowProperty = true
            this.propertyRiskItems = (propertyRiskIndicators || []).map(
              (item) => {
                return {
                  attribute: item.riskIndicator,
                  risk: item.riskLevel,
                  description: item.riskcomments,
                  caution: item.riskDescription,
                  update: item.id,
                }
              }
            )
          }
          this.propertyRiskModel = {
            riskResponseModel: propertyRiskIndicators,
            propertyAddress: this.loanpropertyAddress,
          }
          if (this.finalReportObj.borrowersAndEmployers) {
            this.isShowBorrowerAndEmployerWatchlist = true;
            this.borrowersAndEmployersRiskItems = (
                this.finalReportObj.borrowersAndEmployers.finding || []
              ).map((item) => {
                return {
                  attribute: item.riskIndicator,
                  risk: item.riskLevel,
                  description: item.riskcomments,
                  caution: item.riskDescription,
                  update: item.id,
                }
              })
            this.borrowersAndEmployersItems = (
                this.finalReportObj.borrowersAndEmployers.watchlist || []
              ).flatMap((item) => {
                const borrowerObj = {
                  Name: uppercase(item.name),
                  Role: item.role,
                  ofac: item.ofac,
                  epls: item.epls,
                  hudldp: item.hudLdp,
                  fhfaScpl: item.fhfaScpl,
                  sanctions: item.sanctions,
                  fmel: item.fmel,
                  custom: item.custom,
                  mrb: item.mrb,
                  pep: item.pep,
                  adverseMedia: item.adverseMedia,
                  others: item.others,
                };
                const employersArr = (item.employers || []).map((employer) => ({
                  Name: uppercase(employer.name),
                  Role: employer.role,
                  ofac: employer.ofac,
                  epls: employer.epls,
                  hudldp: employer.hudLdp,
                  fhfaScpl: item.fhfaScpl,
                  sanctions: employer.sanctions,
                  fmel: employer.fmel,
                  custom: employer.custom,
                  mrb: employer.mrb,
                  pep: employer.pep,
                  adverseMedia: employer.adverseMedia,
                  others: employer.others,
                }));
                return [borrowerObj, ...employersArr]
              }
            )
            this.borrowersAndEmployersResultItems = (
                this.finalReportObj.borrowersAndEmployers
                  .results || []
              ).map((item) => {
                return {
                  action: item.status,
                  Name: uppercase(this.formatDisplay(item.name)),
                  Entitytype: this.formatDisplay(item.entityType),
                  Watchlist: this.formatDisplay(item.watchlist),
                  Status: this.formatDisplay(item.status),
                  LisenceNumber: this.formatDisplay(
                    item.licenseNumber
                  ),
                  ExpirationDate: this.formatDisplay(
                    item.expirationDate
                  ),
                  Phone: this.formatDisplay(item.phone),
                  Reason: this.formatDisplay(item.reason),
                  Address: this.formatDisplay(item.address),
                  EntityName: this.formatDisplay(item.entityName),
                  EntityScore: item.entityScore,
                  DeceasedIndicator: this.getPepDeceasedIndicator(
                    item.status
                  ),
                  PepEntries: this.normalizePepEntries(
                    item.pePs ||
                      item.peps ||
                      item.PEPs
                  ),
                  MrbRegistrations: this.getMrbRegistrations(
                    item.entityIDs
                  ),
                  MrbSources: this.getMrbSourceLinks(
                    item.sourceItems
                  ),
                }
              })
          }
          if (this.finalReportObj.participants) {
            this.isShowParticipantReport = true;
            this.participantRiskItems = (
                this.finalReportObj.participants.finding || []
              ).map((item) => {
                return {
                  attribute: item.riskIndicator,
                  risk: item.riskLevel,
                  description: item.riskcomments,
                  caution: item.riskDescription,
                  update: item.id,
                }
              }
            );
            this.participantItems = (
                this.finalReportObj.participants.watchlist || []
              ).map((item) => {
                return {
                  Reference: item.referenceNumber,
                  Name: uppercase(item.name),
                  Role: item.role,
                  ofac: item.ofac,
                  epls: item.epls,
                  hudldp: item.hudLdp,
                  fhfaScpl: item.fhfaScpl,
                  sanctions: item.sanctions,
                  fmel: item.fmel,
                  custom: item.custom,
                  mrb: item.mrb,
                  pep: item.pep,
                  adverseMedia: item.adverseMedia,
                  others: item.others,
                }; 
              }
            );
            this.participantResultItems = (
                this.finalReportObj.participants.results || []
              ).map((item) => {
                return {
                  action: item.status,
                  Name: uppercase(this.formatDisplay(item.name)),
                  Entitytype: this.formatDisplay(item.entityType),
                  Watchlist: this.formatDisplay(item.watchlist),
                  Status: this.formatDisplay(item.status),
                  LisenceNumber: this.formatDisplay(
                    item.licenseNumber
                  ),
                  ExpirationDate: this.formatDisplay(
                    item.expirationDate
                  ),
                  Phone: this.formatDisplay(item.phone),
                  Reason: this.formatDisplay(item.reason),
                  Address: this.formatDisplay(item.address),
                  EntityName: this.formatDisplay(item.entityName),
                  EntityScore: item.entityScore,
                  DeceasedIndicator: this.getPepDeceasedIndicator(
                    item.status
                  ),
                  PepEntries: this.normalizePepEntries(
                    item.pePs ||
                      item.peps ||
                      item.PEPs
                  ),
                  MrbRegistrations: this.getMrbRegistrations(
                    item.entityIDs
                  ),
                  MrbSources: this.getMrbSourceLinks(
                    item.sourceItems
                  ),
                }
              }
            );
            this.licenseVerificationsItems = (
                this.finalReportObj.licenseVerifications || []
              ).map((item) => {
                return {
                  Name: uppercase(item.name),
                  Role: item.role,
                  asc: item.asc,
                  nmls: item.nmls,
                  Entitytype: this.formatDisplay(item.entityType),
                  LicenseNumber: this.formatDisplay(item.licenseNumber),
                  Result: item.result,
                }; 
              }
            );
          }
          // property API-failure errors mapping
          let propertyErrors = this.finalReportObj.errorResponseModel || null
          this.propertyErrorMsg = {
            avm: propertyErrors ? (propertyErrors.avm ? (propertyErrors.avm.trim() ? propertyErrors.avm : null) : null) : null || null,
            // mers
            fema: propertyErrors ? propertyErrors.fema : null || null,
            apr: propertyErrors ? propertyErrors.apr : null || null,
            epr: propertyErrors ? propertyErrors.epr : null || null,
            ars: propertyErrors ? propertyErrors.ars : null || null,
            cmc: propertyErrors ? propertyErrors.cmc : null || null,
            hpi: propertyErrors ? propertyErrors.hpi : null || null,
            phs: propertyErrors ? propertyErrors.borrowerErrorResponse ?
                                      propertyErrors.borrowerErrorResponse.phsProperty.length ? propertyErrors.borrowerErrorResponse.phsProperty[0].message  || null : null
                                    : null
                                  : null,
            propertyRisk: propertyErrors ? propertyErrors.propertyRisk : null || null,
          }
          // participant API-failure errors mapping
          this.bridgerError = this.finalReportObj.errorResponseModel ? this.finalReportObj.errorResponseModel.bridger : null || null
          this.ascError = this.finalReportObj.errorResponseModel ? this.finalReportObj.errorResponseModel.asc : null || null
          // SOF errors
          this.summaryFindingsErrors = {
            borrower: this.customError,
            property: this.propertyErrorMsg.propertyRisk,
            participant: this.participantError,
            borrowerAndEmployer: this.borrowerAndEmployerError
          }
        }
        this.showSpinner = false
      })
    },
    loadBorrowerData() {
      let risklevelItems = []
      let followupItems = []
      this.isShowBorrower = this.validateRecordTypes.includes(
        this.finalReportObj.borrowerDetails.recordType
      )
      this.isShowPersonSearch = this.validateRecordTypes.includes(
        this.finalReportObj.aliases.recordType
      )
      this.ispropertyOwnership = this.validateRecordTypes.includes(
        this.finalReportObj.propertyModel.recordType
      )
      this.isShowAccociatedBusiness = this.validateRecordTypes.includes(
        this.finalReportObj.associatedbusiness.recordType
      )
      this.isShowNodForeclosure = this.validateRecordTypes.includes(
        this.finalReportObj.nodForeclosureModel.recordType
      )
      this.isShowBankruptcy = this.finalReportObj.bankruptcyResponseModel ? this.validateRecordTypes.includes(
        this.finalReportObj.bankruptcyResponseModel.recordType
      ) : false
      this.isShowProfLicenses = this.finalReportObj.professionalLicenseResponseModel ? this.validateRecordTypes.includes(
        this.finalReportObj.professionalLicenseResponseModel.recordType
      ) : false
      this.isShowVOOSection = this.finalReportObj.voOResponseModel ? this.validateRecordTypes.includes(
        this.finalReportObj.voOResponseModel.recordType
      ) : false
      this.isShowRelatives = this.validateRecordTypes.includes(
        this.finalReportObj.relativesAndAssociates.recordType
      )
      this.isShowDriversInfo = this.validateRecordTypes.includes(
        this.finalReportObj.driverlicenceModel.recordType
      )
      this.isShowVoter = this.validateRecordTypes.includes(
        this.finalReportObj.voterRegistration.recordType
      )
      this.isShowEmployer = this.validateRecordTypes.includes(
        this.finalReportObj.employerValidations.recordType
      )
      this.isShowLiens = this.validateRecordTypes.includes(
        this.finalReportObj.liensAndJudgements.recordType
      )
      this.isShowUCCDetails = this.finalReportObj.uccResponseModel ? this.validateRecordTypes.includes(
        this.finalReportObj.uccResponseModel.recordType
      ) : false
      this.isShowCriminalRecords = this.finalReportObj.criminalRecordModel? this.validateRecordTypes.includes(
        this.finalReportObj.criminalRecordModel.recordType
      ) : false
      this.isShowSODetails = this.finalReportObj.sexualOffenseResponseModel ? this.validateRecordTypes.includes(
        this.finalReportObj.sexualOffenseResponseModel.recordType
      ) : false
      this.isShowPropertyHistory = this.validateRecordTypes.includes(
        this.finalReportObj.propertyHistorySearch.recordType
      )
      // this.isShowBorrowerWatchlist = this.validateRecordTypes.includes(
      //   this.finalReportObj.borrowerDetails.watchlistRecordType
      // )
      this.isshowMERS = this.validateRecordTypes.includes(
        this.finalReportObj.mersReportResponse.recordType
      )
      let loanArray = this.finalReportObj.loanInformations || []
      let borrower = []
      if (loanArray.length > 0) {
        loanArray.map((a, ind) => {
          let eCount = 0
          borrower[ind] = this.loanInformationItems.map((item, i) => {
            if (
              this.loanInfoKeys[i] === 'name'
              // this.loanInfoKeys[i] === 'employerName'
            ) {
              return a[this.loanInfoKeys[i]]
                ? uppercase(a[this.loanInfoKeys[i]])
                : null
            } else if(this.employerDataKeys.includes(this.loanInfoKeys[i]))
            {
              // know the employer index from the dynamic keys
              let empIndex = Number(this.loanInfoKeys[i].slice(-1)) - 1
              // fetch the exact value from loanInformations object using index and UI-table key.
              let eData
              if(empIndex < this.isListEmpty(a.employerDetails).length) {
                eData = a.employerDetails[empIndex][this.employerDefaultKeys[eCount++]] || null
              } else eData = null
              eCount = eCount > 3 ? 0 : eCount
              // turn employerName to uppercase
              eData = this.loanInfoKeys[i].includes('employerName') ? uppercase(eData) : eData
              return eData || null
            } else {
              return a[this.loanInfoKeys[i]] || null
            }
          })
        })
        this.loanItems = this.loanInformationItems.map((x, i) => {
          let count = 0
          return {
            indexCol: x.fieldName,
            borrower1:
              loanArray.length > 0 ? borrower[count++][i] || null : null,
            borrower2:
              loanArray.length > 1 ? borrower[count++][i] || null : null,
            borrower3:
              loanArray.length > 2 ? borrower[count++][i] || null : null,
            borrower4:
              loanArray.length > 3 ? borrower[count++][i] || null : null,
            borrower5:
              loanArray.length > 4 ? borrower[count++][i] || null : null,
          }
        })
      }
      this.finalReportObj.loanInformations.map((dataItem, index) => {
        this.loanFields.push({
          key: this.borrowerKeys[index],
          label: `Borrower ${index + 1}`,
          class: 'text-left',
          thStyle: { textAlign: 'left', width: '16.5%' },
          tdClass: 'textTruncatee',
        })
        // get custom errors for third party API failures
        this.loadCustomErrors(index)
        // summary of findings
        if (this.finalReportObj.borrowerDetails && this.finalReportObj.borrowerDetails !== null) {
          this.summaryFindings[index] = {
            borrowerName: this.formatDisplay(dataItem.name),
            riskIndicators: this.filterBorrowerData(
              this.finalReportObj.borrowerDetails.riskIndicators,
              index
            ),
            followUps: this.filterBorrowerData(
              this.finalReportObj.borrowerDetails.followUps,
              index
            ),
          }
          // risk indicators
          followupItems[index] = this.filterBorrowerData(
            this.finalReportObj.borrowerDetails.followUps,
            index
          ).map((item) => {
            return {
              attribute: item.followUp,
              value: item.followUpDetails,
            }
          })
          risklevelItems[index] = this.filterBorrowerData(
            this.finalReportObj.borrowerDetails.riskIndicators,
            index
          ).map((item) => {
            return {
              attribute: item.riskIndicator,
              risk: item.riskLevel,
              description: item.riskcomments,
              caution: item.riskDescription,
              update: item.id,
            }
          })
          // verified information
          this.nameAddressItems[index] = this.filterBorrowerData(
            this.finalReportObj.borrowerDetails.nameAddressSsnVerification,
            index
          ).map((item) => {
            let borrowerDetails
            if (
              (item &&
                item.borrowerHeader &&
                item.borrowerHeader.toLowerCase() === 'first name') ||
              (item &&
                item.borrowerHeader &&
                item.borrowerHeader.toLowerCase() === 'last name')
            ) {
              borrowerDetails = uppercase(item.borrowerDetails)
            } else {
              borrowerDetails = item.borrowerDetails
            }
            return {
              attribute: item.borrowerHeader,
              value: item.borrowerCorrectedDetails ? (item.borrowerCorrectedDetails.trim() ? borrowerDetails + " " + item.borrowerCorrectedDetails
                                                                                           : borrowerDetails)
                                                   : borrowerDetails,
              isVerified: item.verified,
            }
          })
          this.ssnValidateItems[index] = this.filterBorrowerData(
            this.finalReportObj.borrowerDetails.ssnValidations,
            index
          ).map((item) => {
            return {
              attribute: item.borrowerHeader,
              value: item.borrowerDetails,
              isValid: item.valid,
            }
          })
          this.namePhoneItems[index] = this.filterBorrowerData(
            this.finalReportObj.borrowerDetails.nameAddressPhoneVerification,
            index
          ).map((item) => {
            let borrowerDetails
            if (
              (item &&
                item.borrowerHeader &&
                item.borrowerHeader.toLowerCase() === 'first name') ||
              (item &&
                item.borrowerHeader &&
                item.borrowerHeader.toLowerCase() === 'last name')
            ) {
              borrowerDetails = uppercase(item.borrowerDetails)
            } else {
              borrowerDetails = item.borrowerDetails
            }
            return {
              attribute: item.borrowerHeader,
              value: item.borrowerCorrectedDetails ? (item.borrowerCorrectedDetails.trim() ? borrowerDetails + " " + item.borrowerCorrectedDetails
                                                                                           : borrowerDetails)
                                                   : borrowerDetails,
              isVerified: item.verified,
            }
          })
          this.dataLookupItems[index] = this.filterBorrowerData(
            this.finalReportObj.borrowerDetails.usingPhoneNumbers,
            index
          ).map((item) => {
            let data
            if (item && item.record && item.record.toLowerCase() === 'name') {
              data = uppercase(item.data)
            } else {
              data = item.data
            }
            return {
              record: item.record,
              data: data,
            }
          })
          let custData = this.finalReportObj.borrowerDetails
          this.dateOfBirthVerificationItems[index] = this.filterBorrowerData(
            this.finalReportObj.borrowerDetails.dobVerificationModels,
            index
          ).map((item) => {
            return {
              dob: item.borrowerHeader,
              dobDate: item.borrowerDetails,
              Verified: item.verified === 'N' ? (item.verified + (custData.confidenceLevel ?
                                                this.finalReportObj.borrowerDetails.confidenceLevel[index] ?
                                                  ` (${this.finalReportObj.borrowerDetails.confidenceLevel[index]})`
                                                  : ''
                                                : ''))
                                              : item.verified,
            }
          })
          this.deceasedRecordsItems[index] = this.filterBorrowerData(
            this.finalReportObj.borrowerDetails.deceasedRecords,
            index
          ).map((item) => {
            return {
              Record: item.record,
              Data: item.data,
            }
          })
          this.sirNameVariantsItems[index] = this.filterBorrowerData(
            this.finalReportObj.borrowerDetails.surnameVariants,
            index
          ).map((item) => {
            return {
              type: item.type,
              surnameKnown: item.variantFrom ? (item.variantFrom.trim() ? uppercase(item.surnameKnown) + ` (${item.variantFrom})`
                                                                        : uppercase(item.surnameKnown))
                                             : uppercase(item.surnameKnown),
            }
          })
          this.usingAddressItems[index] = this.filterBorrowerData(
            this.finalReportObj.borrowerDetails.usingAddresses,
            index
          ).map((item) => {
            return {
              record: item.record,
              data: item.data,
            }
          })
          this.addressHistoryRecordItems[index] = this.filterBorrowerData(
            this.finalReportObj.borrowerDetails.addressHistories,
            index
          ).map((item) => {
            return {
              Address: item.address,
              PhoneNumber: item.phoneNumber,
              dateFirstSeen: item.dateFirstSeen,
              dateLastSeen: item.dateLastSeen,
              bestAddress: item.bestaddress === true ? 'Y' : 'N',
            }
          })
          // let custData = this.finalReportObj.borrowerDetails
          // this.confidenceLevel[index] = custData.confidenceLevel
          //   ? this.finalReportObj.borrowerDetails.confidenceLevel[index]
          //   : null
          // this.dataSource[index] = custData.dataSource
          //   ? this.finalReportObj.borrowerDetails.dataSource[index]
          //   : null
        }

        // AKAs/Aliases
        if (this.finalReportObj.aliases && this.finalReportObj.aliases !== null) {
          if (
            this.validateRecordTypes.includes(
              this.finalReportObj.aliases.recordType
            )
          ) {
            this.personSearchItems[index] = this.filterBorrowerData(
              this.finalReportObj.aliases.alias,
              index
            ).map((item, i) => {
              return {
                id: i + 1,
                type: item.type,
                Knownalternatives: item.knownalias,
                residenceaddress: item.residenceAddress,
                datefirstseen: item.dateFirstSeen,
                datelastseen: item.dateLastSeen,
              }
            })
          }
        }
        // Property Ownership Search
        if (this.finalReportObj.propertyModel &&
          this.finalReportObj.propertyModel !== null &&
          this.validateRecordTypes.includes(
            this.finalReportObj.propertyModel.recordType
          )
        ) {
          this.propertyOwnershipData[index] = this.filterBorrowerData(
            this.finalReportObj.propertyModel.properties,
            index
          )
        }
        // Associated Business Search
        if (this.finalReportObj.associatedbusiness && this.finalReportObj.associatedbusiness !== null) {
          if (
            this.validateRecordTypes.includes(
              this.finalReportObj.associatedbusiness.recordType
            )
          ) {
            this.asscociatedBusinessData[index] = this.filterBorrowerData(
              this.finalReportObj.associatedbusiness.associatedbusinessModels,
              index
            )
          }
        }
        // NOD Forclosure
        if (this.finalReportObj.nodForeclosureModel && this.finalReportObj.nodForeclosureModel !== null) {
          if (
            this.validateRecordTypes.includes(
              this.finalReportObj.nodForeclosureModel.recordType
            )
          ) {
            this.nodForeclosureModelData[index] = {
              nodforeclosure: this.filterBorrowerData(
                this.finalReportObj.nodForeclosureModel.nodforeclosure,
                index
              ),
            }
          }
        }
        // Bankruptcy Filings
        if(this.finalReportObj.bankruptcyResponseModel && this.finalReportObj.bankruptcyResponseModel !== null && this.isShowBankruptcy) {
          this.bankruptcyData[index] = this.filterBorrowerData(this.finalReportObj.bankruptcyResponseModel.bankruptcyModel, index)
        }
        // Professional Licenses
        if(this.finalReportObj.professionalLicenseResponseModel && this.finalReportObj.professionalLicenseResponseModel !== null && this.isShowProfLicenses) {
          this.profLicensesDetails[index] = this.filterBorrowerData(this.finalReportObj.professionalLicenseResponseModel.professionalLicenseModel, index)
        }
        // Verification of occupancy
        if(this.finalReportObj.voOResponseModel && this.finalReportObj.voOResponseModel !== null && this.isShowVOOSection) {
          let vOData = this.filterBorrowerData(this.finalReportObj.voOResponseModel.voOModel, index)
          this.verificationOccupancyDetails[index] = vOData.length ? vOData[0] : null
          this.vooScore[index] = this.verificationOccupancyDetails[index] && this.verificationOccupancyDetails[index].vooScore !== null ? '(' + this.verificationOccupancyDetails[index].vooScore + ')' : '(0)'
        }
        // Relatives and Associates Search
        if (this.finalReportObj.relativesAndAssociates && this.finalReportObj.relativesAndAssociates !== null) {
          if (
            this.validateRecordTypes.includes(
              this.finalReportObj.relativesAndAssociates.recordType
            )
          ) {
            this.relativesAndAssociates[index] = {
              relatives: this.filterBorrowerData(
                this.finalReportObj.relativesAndAssociates.relatives,
                index
              ),
              associates: this.filterBorrowerData(
                this.finalReportObj.relativesAndAssociates.associates,
                index
              ),
            }
          }
        }
        // Driver's License Search
        if (this.finalReportObj.driverlicenceModel && this.finalReportObj.driverlicenceModel !== null) {
          if (
            this.validateRecordTypes.includes(
              this.finalReportObj.driverlicenceModel.recordType
            )
          ) {
            this.driversLicenseData[index] = this.filterBorrowerData(
              this.finalReportObj.driverlicenceModel.driverLicence,
              index
            )
          }
        }
        // Voter Registration Search
        if (this.finalReportObj.voterRegistration && this.finalReportObj.voterRegistration !== null) {
          if (
            this.validateRecordTypes.includes(
              this.finalReportObj.voterRegistration.recordType
            )
          ) {
            this.voterObject[index] = this.filterBorrowerData(
              this.finalReportObj.voterRegistration.voterRegistrations,
              index
            )
          }
        }
        // Employer Validation
        if (this.finalReportObj.employerValidations && this.finalReportObj.employerValidations !== null) {
          if (
            this.validateRecordTypes.includes(
              this.finalReportObj.employerValidations.recordType
            )
          ) {
            this.employerValidationData[index] = {
              employmentData: this.filterBorrowerData(this.finalReportObj.employerValidations.employerValidations, index),
            }
          }
        }
        // Liens and Judgments
        if (this.finalReportObj.liensAndJudgements && this.finalReportObj.liensAndJudgements !== null) {
          if (
            this.validateRecordTypes.includes(
              this.finalReportObj.liensAndJudgements.recordType
            )
          ) {
            this.liensAndJudgementsData[index] = this.filterBorrowerData(
              this.finalReportObj.liensAndJudgements.liensAndJudgements,
              index
            )
          }
        }
        // UCC Filings
        if(this.finalReportObj.uccResponseModel && this.finalReportObj.uccResponseModel !== null && this.isShowUCCDetails) {
          this.uccDetails[index] = this.filterBorrowerData(this.finalReportObj.uccResponseModel.uccDetailsModel, index)
        }
        // Sexual Offences details
        if(this.finalReportObj.sexualOffenseResponseModel && this.finalReportObj.sexualOffenseResponseModel !== null && this.isShowSODetails) {
          this.sexualOffenceDetails[index] = this.filterBorrowerData(this.finalReportObj.sexualOffenseResponseModel.sexualOffenseDetails, index)
        }
        // Criminal Records
        if (this.finalReportObj.criminalRecordModel && this.finalReportObj.criminalRecordModel !== null && this.isShowCriminalRecords) {
          this.criminalData[index] = this.filterBorrowerData(this.finalReportObj.criminalRecordModel.criminalRecord,index)
        }
        // Property History Search
        if (this.finalReportObj.propertyHistorySearch && this.finalReportObj.propertyHistorySearch !== null && this.isShowPropertyHistory) {
          this.borrowerPHSData[index] = {
            phsData: this.filterBorrowerData(
              this.finalReportObj.propertyHistorySearch.propertyHistoryPackage,
              index
            ),
          }
        }
        // Borrower Watchlists
        // this.borowerResultItems[index] = this.filterBorrowerData(
        //   this.finalReportObj.borrowerDetails.borrowerResponses,
        //   index
        // ).map((item) => {
        //   return {
        //     action: item.searchResult.status,
        //     Name: this.formatDisplay(item.name),
        //     Entitytype: this.formatDisplay(item.entityType),
        //     Watchlist: this.formatDisplay(item.watchlist),
        //     SubmittedDetails: this.formatDisplay(item.submittedDetails),
        //     Status: this.formatDisplay(item.searchResult.status),
        //     LisenceNumber: this.formatDisplay(item.searchResult.licenseNumber),
        //     ExpirationDate: this.formatDisplay(
        //       item.searchResult.expirationDate
        //     ),
        //     Phone: this.formatDisplay(item.searchResult.phone),
        //     Reason: this.formatDisplay(item.searchResult.reason),
        //     Address: this.formatDisplay(item.searchResult.address),
        //   }
        // })
        // let noHitData = (
        //   this.finalReportObj.borrowerDetails.noHitModel || []
        // ).find((x) => x.borrowerIndex === index + 1)
        // this.borrowerApiSuccess[index] = noHitData
        //   ? noHitData.isApiSuccess
        //   : false
        // MERS
        if (this.finalReportObj.mersReportResponse && this.finalReportObj.mersReportResponse !== null) {
          if (this.isshowMERS) {
            this.mersResponse[index] = {
              mersResponse: this.filterBorrowerData(
                this.finalReportObj.mersReportResponse
                  .mersReportResponseDetails,
                index
              ),
              ssn: dataItem.ssn,
            }
          }
        }
      })
      this.borrowerArray = this.finalReportObj.loanInformations.map(
        (x, ind) => {
          let uniqueIDFailedStatus = this.finalReportObj.borrowerDetails.recordType ? this.checkInstantIDStatus(this.finalReportObj.borrowerDetails.borrowerUniqueId || [], ind) : true
          return {
            isborrowerCollapsed: false,
            isVisibleVI: false,
            isVisibleAliases: false,
            isVisibleVoters: false,
            isVisibleLiens: false,
            isVisibleUcc: false,
            isVisibleOffenses: false,
            isVisibleEmployer: false,
            isVisiblePropertyOwner: false,
            isVisibleRelatives: false,
            isVisibleDrivers: false,
            isVisibleAssociatedBusiness: false,
            isVisibleNodForeclosure: false,
            isVisibleBankruptcy: false,
            isVisibleProfLicenses: false,
            isVisibleVOO: false,
            ...x,
            risklevelItems: risklevelItems[ind],
            followupItems: followupItems[ind],

            // borrower products to be shown irrespective of UniqueID failure/success.
            isShowBorrower: this.isShowBorrower,
            isShowAccociatedBusiness: this.isShowAccociatedBusiness,
            isShowVOOSection: this.isShowVOOSection,
            isShowEmployer: this.isShowEmployer,
            isShowPropertyHistory: this.isShowPropertyHistory,
            isshowMERS: this.isshowMERS,

            // borrower products to be shown based the success/failure of UniquieID.
            isShowPersonSearch: this.isShowPersonSearch && uniqueIDFailedStatus,
            ispropertyOwnership: this.ispropertyOwnership && uniqueIDFailedStatus,
            isShowNodForeclosure: this.isShowNodForeclosure && uniqueIDFailedStatus,
            isShowBankruptcy: this.isShowBankruptcy && uniqueIDFailedStatus,
            isShowProfLicenses: this.isShowProfLicenses && uniqueIDFailedStatus,
            isShowRelatives: this.isShowRelatives && uniqueIDFailedStatus,
            isShowDriversInfo: this.isShowDriversInfo && uniqueIDFailedStatus,
            isShowVoter: this.isShowVoter && uniqueIDFailedStatus,
            isShowLiens: this.isShowLiens && uniqueIDFailedStatus,
            isShowUCCDetails: this.isShowUCCDetails && uniqueIDFailedStatus,
            isShowCriminalRecords: this.isShowCriminalRecords && uniqueIDFailedStatus,
            isShowSODetails: this.isShowSODetails && uniqueIDFailedStatus,
          }
        }
      )
    },
    isListEmpty(list) {
      // to handle empty list when sent as null or [] from API
      return list ? (list.length ? list || [] : []) : []
    },
    checkInstantIDStatus(errors, ind) {
      let errorMsg
      (errors || []).find((x) => {
        if(x.borrowerIndex === ind + 1) {
          errorMsg = !x.uniqueIDFailed
        }
      })
      return errorMsg || true
    },
    loadCustomErrors(index) {
      var ErrorData = this.finalReportObj.errorResponseModel ? this.finalReportObj.errorResponseModel.borrowerErrorResponse ?
                                                                 this.finalReportObj.errorResponseModel.borrowerErrorResponse
                                                               : null
                                                              : null
      // borrower API-failure errors mapping
      this.customError[index] = {
        verifiedInfo: this.filterBorrowerErrors(ErrorData ? ErrorData.instantId : [], index),
        akas: this.filterBorrowerErrors(ErrorData ? ErrorData.aka : [], index),
        propertyOwnership: this.filterBorrowerErrors(ErrorData ? ErrorData.pos : [], index),
        associateBusiness: this.filterBorrowerErrors(ErrorData ? ErrorData.associatedBusiness : [], index),
        nod: this.filterBorrowerErrors(ErrorData ? ErrorData.nod : [], index),
        relativesAndAssociates: this.filterBorrowerErrors(ErrorData ? ErrorData.relativesAndAssociates : [], index),
        driversLicense: this.filterBorrowerErrors(ErrorData ? ErrorData.driversLicense : [], index),
        voterRegistration: this.filterBorrowerErrors(ErrorData ? ErrorData.voterRegistration : [], index),
        employerValidation: this.filterBorrowerErrors(ErrorData ? ErrorData.employerValidation : [], index),
        liensAndJudge: this.filterBorrowerErrors(ErrorData ? ErrorData.liensAndJudgement : [], index),
        phs: this.filterBorrowerErrors(ErrorData ? ErrorData.phsBorrower : [], index),
        mers: this.filterBorrowerErrors(ErrorData ? ErrorData.mersBorrower : [], index),
        borrowerRisk: this.filterBorrowerErrors(ErrorData ? ErrorData.borrowerRisk : [], index),
        uccDetail: this.filterBorrowerErrors(ErrorData ? ErrorData.uccDetail : [], index),
        sexualOffense: this.filterBorrowerErrors(ErrorData ? ErrorData.sexualOffense : [], index),
        bankruptcy: this.filterBorrowerErrors(ErrorData ? ErrorData.bankruptcy : [], index),
        professionalLicense: this.filterBorrowerErrors(ErrorData ? ErrorData.professionalLicense : [], index),
        voo: this.filterBorrowerErrors(ErrorData ? ErrorData.voo : [], index),
        criminalRecord: this.filterBorrowerErrors(ErrorData ? ErrorData.criminalRecord : [], index),
      }
    },
    filterBorrowerErrors(item, row) {
      let errorMsg
      (item || []).filter((x) => {
        if(x.borrowerIndex === row + 1) {
          errorMsg = x.message
        }
      })
      return errorMsg || null
    },
    filterBorrowerData(item, row) {
      return (item || []).filter((x) => x.borrowerIndex === row + 1) || []
    },
    formatDisplay(value) {
      return value || ''
    },
    formatDate(value) {
      if(!value){
        return '';
      }
      let date = new Date(value);
      return date.toLocaleDateString('en-CA');
    },
    displayBorrowerRisks(followUps, risks) {
      return !(followUps.length && !risks.length)
    },
    formatHpiValues(value) {
      return value < 0 ? value*-1 : value
    },
    watchListStatus(value, type) {
      return (value || null) ? value.toLowerCase() === type : false
    },
    normalizePepEntries(peps) {
      return (peps || []).filter((item) => item).map((pep) => {
        return {
          country: this.formatDisplay(pep.country || pep.Country),
          institution: this.formatDisplay(
            pep.governingInstitution || pep.GoverningInstitution
          ),
          role: this.formatDisplay(
            pep.governingRole ||
              pep.GoverningRole ||
              pep.subcategories ||
              pep.Subcategories
          ),
          status: this.formatDisplay(pep.status || pep.Status),
        }
      })
    },
    getPepDeceasedIndicator(status) {
      if (!status) return 'No Information Found'
      const normalized = status.toLowerCase()
      if (normalized === 'deceased') return 'Yes'
      if (normalized === 'alive') return 'No'
      return 'No Information Found'
    },
    getMrbRegistrations(entityIDs) {
      return (entityIDs || []).filter((item) => {
        return item && (item.number || item.issuer)
      })
    },
    getMrbSourceLinks(sourceItems) {
      return (sourceItems || []).filter((item) => {
        return item && item.uri && this.isGovSourceLink(item.uri)
      })
    },
    isGovSourceLink(uri) {
      try {
        return new URL(uri).hostname.toLowerCase().endsWith('.gov')
      } catch (error) {
        return false
      }
    },
    getArrow(value) {
      let direction = Number(value) < this.hpiBaseScore ? 'down' : 'up'
      return Number(value) <= this.hpiScoreLimit
        ? require(`@assets/images/arrowYellow-${direction}.png`)
        : require(`@assets/images/arrowRed-${direction}.png`)
    },
    // setHTMLContent(value) {
    //   document.getElementById('myelement').style.display = value
    //   if (this.showBorrowerSection) {
    //     this.borrowerArray.map((x, ind) => {
    //       document.getElementById(`borrowerdetails${ind}`).style.display = value
    //     })
    //   }
    //   if (this.isShowProperty) {
    //     document.getElementById('propertydetails').style.display = value
    //   }
    //   if (this.isShowParticipantReport) {
    //     document.getElementById('participantdetails').style.display = value
    //   }
    //   document.getElementById('frxFooter').style.display = value
    // },
    // printpdf(elem) {
    //   this.setHTMLContent('none')
    //   let borrowerId = ''
    //   if (elem.includes('borrowerdetails')) {
    //     borrowerId = elem
    //     elem = 'borrowerdetails'
    //   }
    //   switch (elem) {
    //     case 'myelement':
    //       document.getElementById('myelement').style.display = 'block'
    //       break
    //     case 'borrowerdetails':
    //       document.getElementById(borrowerId).style.display = 'block'
    //       break
    //     case 'propertydetails':
    //       document.getElementById('propertydetails').style.display = 'block'
    //       break
    //     case 'participantdetails':
    //       document.getElementById('participantdetails').style.display = 'block'
    //       break
    //   }
    //   window.print()
    //   this.setHTMLContent('block')
    //   // if (Array.isArray(this.$refs[elem])) {
    //   //   this.$refs[elem][0].downloadPDF()
    //   // } else this.$refs[elem].downloadPDF()
    // },
    // get FrX PDF report from API
    getFrXPDFFromAPI(section) {
      this.showSpinner = true
      let payload = {
        orderId: this.ORDER_ID,
        section: section
      }
      // common method call to download PDF when this report loads from different sources
      this.getFraudXPDFReport(payload, this.TOKEN).then((response) => {
        if (response && response.status === 200) {
          common.downloadFile(
                  response.data,
                  constant.contentType.pdf,
                  "Fraud ReportX",
                  true
                )
        }
        this.showSpinner = false
      }).catch((error) => {
            this.autherror = error
            this.setAlert({
              title: constant.imageHeaderError,
              msg: constant.errorMessage,
              variant: constant.errorMessagetype,
            })
            this.showSpinner = false
          })
    },
    updatedcomments(id, status) {
      this.openRiskModal()
      this.indexid = id
      this.borrowerRiskStatus = status
      this.borrowerRiskComment = ''
      this.riskStatus = status
    },
    concatString() {
      let dateTime = new Date().toLocaleString('en-US', {
        timeZone: 'America/New_York',
      })
      let name = `${this.User_Name} , ${format(dateTime, 'MM/DD/YYYY')} , ${format(dateTime, 'hh:mm:ss A')}- ${this.borrowerRiskComment}`
      let status = `${this.User_Name} , ${format(dateTime, 'MM/DD/YYYY')} , ${format(dateTime, 'hh:mm:ss A')}- Status Change ${this.riskStatus} -> ${this.borrowerRiskStatus}`
      if (this.riskStatus !== this.borrowerRiskStatus) {
        this.isClearedStatus = true
        if (this.borrowerRiskComment) {
          this.satusDescription = status
          this.commentDescription = name
        } else this.satusDescription = status
      } else {
        if (this.borrowerRiskComment) this.commentDescription = name
        else return null
      }
    },
    updateStatus() {
      if (this.concatString() !== null) {
        this.showUpdateStatusModal = false
        this.showSpinner = true
        this.saveFPlusStatus(
          {
            CommentsDescription: this.commentDescription,
            StatusDescription: this.satusDescription,
            Status: this.borrowerRiskStatus,
            riskindicatorid: this.indexid,
          },
          this.TOKEN
        )
          .then((response) => {
            if (response.status === 200) {
              // borrower risk items
              this.borrowerArray.map((x, index) => {
                x.risklevelItems.map((i) => {
                  if (i.update === this.indexid) {
                    if (this.isClearedStatus) {
                      i.description.push(this.satusDescription)
                      i.description.push(this.commentDescription)
                      i.caution = this.borrowerRiskStatus
                    } else {
                      i.description.push(this.commentDescription)
                      i.caution = this.borrowerRiskStatus
                    }
                  }
                })
                this.summaryFindings.map((b) => {
                  b.riskIndicators.map((i) => {
                    if (i.id === this.indexid) {
                      i.riskDescription = this.borrowerRiskStatus
                    }
                  })
                })
              })
              // property risk items
              this.propertyRiskItems.map((x) => {
                if (x.update === this.indexid) {
                  if (this.isClearedStatus) {
                    x.description.push(this.satusDescription)
                    x.description.push(this.commentDescription)
                    x.caution = this.borrowerRiskStatus
                  } else {
                    x.description.push(this.commentDescription)
                    x.caution = this.borrowerRiskStatus
                  }
                }
              })
              this.propertyRiskModel.riskResponseModel.map((x) => {
                if (x.id === this.indexid) {
                  x.riskDescription = this.borrowerRiskStatus
                }
              })
              // borrowersAndEmployers risk items
              this.borrowersAndEmployersRiskItems.map((x) => {
                if (x.update === this.indexid) {
                  if (this.isClearedStatus) {
                    x.description.push(this.satusDescription)
                    x.description.push(this.commentDescription)
                    x.caution = this.borrowerRiskStatus
                  } else {
                    x.description.push(this.commentDescription)
                    x.caution = this.borrowerRiskStatus
                  }
                }
              })
              // participant risk items
              this.participantRiskItems.map((x) => {
                if (x.update === this.indexid) {
                  if (this.isClearedStatus) {
                    x.description.push(this.satusDescription)
                    x.description.push(this.commentDescription)
                    x.caution = this.borrowerRiskStatus
                  } else {
                    x.description.push(this.commentDescription)
                    x.caution = this.borrowerRiskStatus
                  }
                }
              })
              if (this.participantreportItems.riskIndicators) {
                this.participantreportItems.riskIndicators.map((x) => {
                  if(x.id === this.indexid) {
                    x.riskDescription = this.borrowerRiskStatus
                  }
                })
              }
              this.satusDescription = ''
              this.commentDescription = ''
              this.showSpinner = false
              this.isClearedStatus = false
            }
          })
          .catch((error) => {
            this.showSpinner = false
            this.autherror = error
            this.setAlert({
              title: constant.imageHeaderError,
              msg: constant.errorMessage,
              variant: constant.errorMessagetype,
            })
          })
      }
    },
    updateStatusremarks() {
      let dateTime = new Date().toLocaleString('en-US', {
        timeZone: 'America/New_York',
      })
      if (this.borrowerComment) {
        this.showCommentModal = false
        this.showSpinner = true
        let statuscomment = `${this.User_Name} , ${format(dateTime, 'MM/DD/YYYY')} , ${format(dateTime, 'hh:mm:ss A')} ${this.borrowerComment}`
        this.saveFPlusRemarks(
          {
            comments: statuscomment,
            orderID: this.ORDER_ID,
          },
          this.TOKEN
        )
          .then((response) => {
            if (response.status === 200) {
              this.commentsProperty.push(statuscomment)
            }
            this.showSpinner = false
          })
          .catch((error) => {
            this.autherror = error
            this.setAlert({
              title: constant.imageHeaderError,
              msg: constant.errorMessage,
              variant: constant.errorMessagetype,
            })
            this.showSpinner = false
          })
      }
    },
    // mapPropertyHistorySearch(propertyData, dataIndex = -1) {
    //   let addressData =
    //     dataIndex >= 0
    //       ? this.filterBorrowerData(propertyData.addressModels || [], dataIndex)
    //       : propertyData.addressModels
    //   var addressModalList = propertyData.addressModels.length
    //     ? addressData || []
    //     : []
    //   if (propertyData.recordType === this.dataRetrived) {
    //     if (propertyData.propertyHistoryPackage.length) {
    //       var PHSList = []
    //       propertyData.propertyHistoryPackage.forEach((element) => {
    //         let propertyList = []
    //         let transactionList = []
    //         if (element.propertyReportResponse.length > 0) {
    //           let filteredData =
    //             dataIndex >= 0
    //               ? this.filterBorrowerData(
    //                   element.propertyReportResponse,
    //                   dataIndex
    //                 )
    //               : element.propertyReportResponse
    //           filteredData.forEach((item) => {
    //             let ownerlist = ''
    //             if (item.owners.length > 0) {
    //               item.owners.forEach((x) => {
    //                 ownerlist = ownerlist ? ownerlist + ', ' + x : x
    //               })
    //             }
    //             propertyList.push({
    //               address: item.address,
    //               address1: item.address1,
    //               apn: this.formatDisplay(item.apn),
    //               legalDescription: this.formatDisplay(item.legalDescription),
    //               subDivisionName: this.formatDisplay(item.subDivisionName),
    //               landUse: this.formatDisplay(item.landUse),
    //               landValue: this.formatDisplay(item.landValue),
    //               improvementValue: this.formatDisplay(item.improvementValue),
    //               assesedValue: this.formatDisplay(item.assesedValue),
    //               marketLandValue: this.formatDisplay(item.marketLandValue),
    //               marketImprovementValue: this.formatDisplay(
    //                 item.marketImprovementValue
    //               ),
    //               totalMarketValue: this.formatDisplay(item.totalMarketValue),
    //               taxAmount: this.formatDisplay(item.taxAmount),
    //               taxYear: this.formatDisplay(item.taxYear),
    //               owners: this.formatDisplay(ownerlist),
    //               recordDate: this.formatDisplay(item.recordDate),
    //             })
    //           })
    //         }
    //         if (element.chronoResponseModel.length > 0) {
    //           let filteredData =
    //             dataIndex >= 0
    //               ? this.filterBorrowerData(
    //                   element.chronoResponseModel,
    //                   dataIndex
    //                 )
    //               : element.chronoResponseModel
    //           filteredData.forEach((x) => {
    //             let buyerItem = ''
    //             let sellerItem = ''
    //             if (x.buyer.length > 0) {
    //               x.buyer.forEach((x) => {
    //                 buyerItem = buyerItem ? buyerItem + ', ' + x : x
    //               })
    //             }
    //             if (x.seller.length > 0) {
    //               x.seller.forEach((x) => {
    //                 sellerItem = sellerItem ? sellerItem + ', ' + x : x
    //               })
    //             }
    //             transactionList.push({
    //               Sale_Date: this.formatDisplay(x.saleDate),
    //               Buyer: this.formatDisplay(buyerItem),
    //               Seller: this.formatDisplay(sellerItem),
    //               Sale_price: this.formatDisplay(x.salePrice),
    //               Loan_Amount: this.formatDisplay(x.loanAmout),
    //               Lender: this.formatDisplay(x.lender),
    //               Document_Type: this.formatDisplay(x.documentType),
    //               Recording_Date: this.formatDisplay(x.recordDate),
    //               address: x.address,
    //               address1: x.address1,
    //             })
    //           })
    //         }
    //         PHSList.push({
    //           tranactionDetails: transactionList,
    //           propertyDetails: propertyList,
    //         })
    //       })
    //       var PHSData = {
    //         propertyHistoryList: PHSList,
    //         addressModalList: addressModalList,
    //       }
    //     }
    //   }
    //   return PHSData
    // },
    closeStatusModal() {
      this.showUpdateStatusModal = false
      this.showCommentModal = false
    },
    openRiskModal() {
      this.showUpdateStatusModal = true
    },
    openCommentModal() {
      this.showCommentModal = true
      this.borrowerComment = ''
    },
    getCell(col) {
      return `cell(${col})`
    },
    arsSortingChanged(sortData) {
      if (sortData.sortBy) {
        this.showSpinner = true
        let columnName = ''
        switch (sortData.sortBy) {
          case 'address':
            columnName = 'Address'
            break
          case 'distance':
            columnName = 'Distance'
            break
          case 'lastSalePrice':
            columnName = 'LastSalePrice'
            break
          case 'lastSaleDate':
            columnName = 'LastSaleDate'
            break
          case 'mainSqft':
            columnName = 'MainSqFt'
            break
          case 'lotSize':
            columnName = 'LotSize'
            break
          case 'beds':
            columnName = 'Beds'
            break
          case 'bath':
            columnName = 'Bath'
            break
          case 'yearBuilt':
            columnName = 'YearBuilt'
            break
          case 'propStyle':
            columnName = 'PropStyle'
            break
          case 'reo':
            columnName = 'REO'
            break
        }
        let sortObj = {
          orderId: this.ORDER_ID,
          sortBy: columnName,
          sortType: sortData.sortDesc ? 1 : 0,
        }
        this.getARSSortedData(sortObj, this.TOKEN)
          .then((response) => {
            if (response.status === 200) {
              this.areaRecentSalesItems = (response.data || []).map((item) => {
                return {
                  slno: this.formatDisplay(item.property),
                  address: this.formatDisplay(item.address),
                  distance: this.formatDisplay(item.distance),
                  lastSalePrice: this.formatDisplay(item.lastSalePrice),
                  lastSaleDate: this.formatDisplay(item.lastSaleDate),
                  mainSqft: this.formatDisplay(item.mainSqFt),
                  lotSize: this.formatDisplay(item.lotSize),
                  beds: this.formatDisplay(item.beds),
                  bath: this.formatDisplay(item.bath),
                  yearBuilt: this.formatDisplay(item.yearBuilt),
                  propStyle: this.formatDisplay(item.propStyle),
                  reo: this.formatDisplay(item.reo),
                }
              })
              this.showSpinner = false
            }
          })
          .catch((error) => {
            this.autherror = error
            this.setAlert({
              title: constant.imageHeaderError,
              msg: constant.errorMessage,
              variant: constant.errorMessagetype,
            })
            this.showSpinner = false
          })
      }
    },
    turnBold(str, substr) {
      return str ? str.replaceAll(substr, substr.bold()) : ''
    },
  },
}
</script>
<template>
  <div class="body--wrapper  bg-white  container">
    <BaseSpinner v-if="showSpinner"></BaseSpinner>
    <BaseModalLayout
      :show-modal="showUpdateStatusModal"
      modal-title="Update Status"
      modal-size="md"
      modal-header-class="fraudPlusStatusModalHeader"
      modal-body-class="fraudPlusStatusModalBody"
      modal-footer-class="fraudPlusStatusModalFooter"
      modal-title-class="fraudPlusStatusModalTitle"
      ok-button-class="fraudPlusStatusModalButton updateStatusModalPrimaryBtn"
      cancel-button-class="fraudPlusStatusModalButton updateStatusModalCancelBtn"
      ok-variant="Update"
      cancel-variant="Cancel"
      @confirmOkClicked="updateStatus"
      @confirmCancelClicked="closeStatusModal"
    >
      <div class="fraudPlusStatusModalContent">
        <b-row>
          <b-col md="12">
            <BaseELabel class="updateStatusModalLabel" label="Status" />
            <BaseDropdown
              v-model="borrowerRiskStatus"
              :options="borrowerRiskList"
              show-select-as-option="NO"
              name="borrowerRiskStatus"
              class="updateStatusModalField mb-1"
            ></BaseDropdown>
          </b-col>
          <b-col class="updateStatusCommentGroup" md="12">
            <BaseTextarea
              id="riskcomment"
              v-model="borrowerRiskComment"
              maxlength="250"
              name="borrowerRiskComment"
              rows="3"
              label-content="Comment"
              allow-resize
              class="updateStatusModalField"
            ></BaseTextarea>
          </b-col>
        </b-row>
      </div>
    </BaseModalLayout>
    <BaseModalLayout
      :show-modal="showCommentModal"
      modal-title="Add Comment"
      modal-size="md"
      modal-header-class="fraudPlusStatusModalHeader"
      modal-body-class="fraudPlusStatusModalBody"
      modal-footer-class="fraudPlusStatusModalFooter"
      modal-title-class="fraudPlusStatusModalTitle"
      ok-button-class="fraudPlusStatusModalButton addCommentModalPrimaryBtn"
      cancel-button-class="fraudPlusStatusModalButton addCommentModalCancelBtn"
      ok-variant="Update"
      cancel-variant="Cancel"
      @confirmOkClicked="updateStatusremarks"
      @confirmCancelClicked="closeStatusModal"
    >
      <div class="fraudPlusStatusModalContent">
        <b-row>
          <b-col class="updateStatusCommentGroup" md="12">
            <BaseTextarea
              id="riskcomment"
              v-model="borrowerComment"
              maxlength="250"
              name="borrowerComment"
              rows="3"
              label-content="Comment"
              allow-resize
              class="addCommentModalField"
            ></BaseTextarea>
          </b-col>
        </b-row>
      </div>
    </BaseModalLayout>
    <b-row class="headerTextStyle">
        <b-col>
          <b-alert show class="headerAlert">
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <img src="@assets/images/info-icon.svg"/>
              </div>
              <div class="headerAlertText">{{ fraudXHeaderData }}</div>
            </div>
          </b-alert>
        </b-col>
    </b-row>
    <div id="myelement">
      <!-- <VueHtmlAsPdf ref="myelement" reference="myelement"> -->
      <div class="mx-3">
        <b-row class="bg-white pt-2" align-v="center">
          <b-col md="7" class="p-0 d-flex ">
            <img src="@assets/images/xactus-logo-intelligent.svg"/>
            <div class="ml-4 pl-4 py-1 headerXactusData">
              <div class="pb-1">370 Reed Rd., Suite 100 </div>
              <div>Broomall, PA 19008 | 800-549-8782</div>
            </div>
          </b-col>
          <b-col md="5" class="p-0 text-right">
            <div class="d-flex align-items-center justify-content-end">
              <img src="@assets/images/product-flag.svg"/>
              <span class="fraudReportLogoText">Fraud ReportX</span>
            </div>
          </b-col>
        </b-row>
        <b-row class="pt-2 pb-4">
          <b-col class="p-0 d-flex justify-content-end">
            <div class="p-2 d-flex">
              <img src="@assets/images/print-icon.svg" class="pr-2"/>
              <b-link class="fraudReportPrintLink" @click="getFrXPDFFromAPI('fullreport')">Print Report</b-link>
            </div>
            <div class="d-flex p-2">
              <img src="@assets/images/print-icon.svg" class="pr-2"/>
              <b-link class="fraudReportPrintLink" @click="getFrXPDFFromAPI('coverpage')">Print Summary of Findings</b-link>
            </div>
          </b-col>
        </b-row>
        <b-row :class="$style.bgGrey" class="baseContentFont">
          <b-col md="4" :class="$style.label"
            ><strong>Report ID:</strong> {{ reportNumber }}</b-col
          >
          <b-col md="4" :class="$style.label"
            ><strong>Date Ordered:</strong> {{ dateOrdered }}</b-col
          >
          <b-col md="4" :class="$style.label"
            ><strong>Customer Number:</strong> {{ customerNumber }}</b-col
          >
          <b-col md="4" :class="$style.label"
            ><strong>Reference Number:</strong> {{ referenceNumber }}
          </b-col>
          <!-- <b-col md="4" :class="$style.label"
            ><strong>Date Last Modified:</strong> {{ lastDateModified }}
          </b-col> -->
          <b-col md="4" :class="$style.label"
            ><strong>Ordered By: </strong>{{ orderBy }}
          </b-col>
          <b-col md="4" :class="$style.label"
            ><strong>Customer Name:</strong> {{ customerName }}
          </b-col>
          <b-col md="4" :class="$style.label"
            ><strong>Customer Address:</strong> {{ customerAddress }}
          </b-col>
          <b-col v-if="primaryborrowerName" md="4" :class="$style.label"
            ><strong>Borrower Name:</strong> {{ primaryborrowerName }}
          </b-col>
        </b-row>
      </div>
      <!-- Loan Information -->
      <!-- <div class="baseContentFont">
        <b-row class="loanInfoHeader mx-0 fontWeightMedium">
          <b-col class="pt-2">Loan Information</b-col>
          <b-col
            v-for="(item, ind) in borrowerArray"
            :key="ind"
            class="loanBorder pt-2"
          >
            <div>Borrower {{ ind + 1 }}</div>
          </b-col>
        </b-row>
        <b-row align-v="center" class="border mx-0">
          <b-col class="px-0">
            <div class="loanData">
              <div class="labelContent">Name</div>
              <div>Credit Order ID</div>
              <div>SSN</div>
              <div class="labelContent">Address</div>
              <div>DOB</div>
              <div>Home Phone</div>
              <div>Mobile Phone</div>
              <div>Driver's License</div>
              <div>Employer Status</div>
              <div>Employer Name</div>
              <div class="labelContent">Employer Address</div>
              <div>Employer Phone</div>
            </div>
          </b-col>
          <b-col v-for="(item, i) in borrowerArray" :key="i" class="px-0">
            <div class="loanData">
              <div class="labelContent">{{ item.name }}</div>
              <div>{{ item.creditOrderId }}</div>
              <div>{{ item.ssn }}</div>
              <div class="labelContent">{{ item.address }}</div>
              <div>{{ item.dob }}</div>
              <div>{{ item.homePhoneNumber }}</div>
              <div>{{ item.cellPhoneNumber }}</div>
              <div>{{ item.driverLicence }}</div>
              <div>{{ item.employmentStatus }}</div>
              <div>{{ item.employerName }}</div>
              <div class="labelContent">{{ item.employerAddress }}</div>
              <div>{{ item.employerPhone }}</div>
            </div>
          </b-col>
        </b-row>
        <div class="mx-0 my-2 loanData">
          <div
            ><span class="mr-5">Property Address : </span
            >{{ loanpropertyAddress }}</div
          >
        </div>
      </div> -->
      <!-- Loan Information -->
      <b-row v-if="!isBatchOrder">
        <b-col>
          <b-table
            bordered
            responsive
            striped
            :fields="loanFields"
            :items="loanItems"
            class="loantableHead mb-0"
          >
            <template slot="bottom-row">
              <td :colspan="loanFields.length" class="baseContentFont text-left pl-2">
                <span>Property Address: </span>{{ loanpropertyAddress | uppercase }}
              </td>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <!-- summary of findings -->
      <div>
        <BaseFinding
          :associated-business="summaryFindings"
          :property-information="propertyRiskModel"
          :borrower-and-employer-risk-items="borrowersAndEmployersRiskItems"
          :participant-risk-items="participantRiskItems"
          :show-property-details="showPropertySection"
          :show-borrower-details="showBorrowerSection"
          :show-borrower-and-employer-details="showBorrowerAndEmployerDetails"
          :show-participant-details="showParticipantDetails"
          :is-batch-order="isBatchOrder"
          :property-comments="commentsProperty"
          :summary-errors="summaryFindingsErrors"
          :read-only="isReadOnly"
          @addcomments="openCommentModal"
          @addupdated="updatedcomments"
        />
      </div>
      <!-- </VueHtmlAsPdf> -->
    </div>
    <!-- ========== Borrower section starts ==========-->
    <div v-if="showBorrowerSection">
      <div
        v-for="(item, index) in borrowerArray"
        :id="`borrowerdetails${index}`"
        :key="index"
        class="border my-3"
      >
        <!-- <VueHtmlAsPdf
          :ref="`borrowerdetails${index}`"
          :reference="`borrowerdetails${index}`"
        > -->
        <div no-body class="mb-1 p-1 bg-white">
          <div header-tag="header" class="p-1" role="tab">
            <b-button
              v-b-toggle="`collapse-borrower${index}`"
              block
              class="d-flex collapseStyle"
              :class="$style.nooutline"
              @click="item.isborrowerCollapsed = !item.isborrowerCollapsed"
            >
              <p class="mb-0"
                ><b
                  >Borrower Detail Report
                  <span> - {{ item.name }}</span></b
                ></p
              >
              <strong class="ml-auto"
                ><i
                  :class="`fa fa-angle-${item.isborrowerCollapsed ? 'up' : 'down'
                    } text-white`
                    "
                ></i
              ></strong>
            </b-button>
          </div>
          <b-collapse :id="`collapse-borrower${index}`" visible>
            <b-row>
              <b-col class="d-flex justify-content-end">
                <div class="d-flex printReportCustom" :class="$style.printReportLink">
                  <img src="@assets/images/print-icon.svg" class="pr-2"/>
                  <b-link class="fraudReportPrintLink" @click="getFrXPDFFromAPI(`borrowerdetails${index + 1}`)">Print Report</b-link>
                </div>
              </b-col>
            </b-row>
            <div :class="$style.borrowerReport">
              <div v-if="displayBorrowerRisks(item.followupItems, item.risklevelItems)">
              <RiskIndicators
                class="my-1"
                :risk-indicators="item.risklevelItems"
                :risk-error="customError[index].borrowerRisk"
                :read-only="isReadOnly"
                @addupdated="updatedcomments"
              />
              </div>
              <div v-if="item.followupItems.length">
                <b-table
                  bordered
                  responsive
                  striped
                  :fields="followupFields"
                  :items="item.followupItems"
                  :options="options"
                  :class="['roundedReportTable', { 'mb-0': !item.followupItems.length }]"
                  thead-class="d-none"
                ></b-table>
              </div>
            </div>
            <!-- Verified Information -->
            <div v-if="item.isShowBorrower">
              <div role="tablist">
                <div no-body class="mb-1 p-1 bg-white">
                  <div header-tag="header" class="p-1 verifiedInfoHeader" role="tab">
                    <b-button
                      v-b-toggle="`accordion-2${index}`"
                      block
                      class="d-flex collapseHeadStyle"
                      :class="$style.nooutline"
                      @click="item.isVisibleVI = !item.isVisibleVI"
                    >
                      <p class="mb-0 text-dark font-weight-bold">Verified Information</p>
                      <strong class="ml-auto"
                        ><i
                          :class="`fa fa-angle-${item.isVisibleVI ? 'up' : 'down'
                            } text-dark`
                            "
                        ></i
                      ></strong>
                    </b-button>
                  </div>

                  <b-collapse :id="`accordion-2${index}`" visible>
                    <div v-if="customError[index].verifiedInfo === null" class="mx-1">
                      <b-row class="mt-2">
                        <b-col sm="12" md="12">
                          <BaseELabel label="Name/Address/SSN Verification" class="mb-2" new-style />
                          <b-table
                            bordered
                            responsive
                            striped
                            :fields="nameAddressFields"
                            :items="nameAddressItems[index]"
                            :options="options"
                            :class="{
                              'mb-0': !nameAddressItems[index].length,
                              'fraudReportHeaderTable': true,
                            }"
                          >
                            <template v-slot:cell(isVerified)="data">
                              <span
                                :class="{
                                  'verifyStateN': data.item && data.item.isVerified && data.item.isVerified === 'N',
                                  'verifiedCell': true,
                                }"
                              >
                                {{ data.item.isVerified }}
                              </span>
                            </template>
                          </b-table>
                          <NoRecordFound
                            v-if="!nameAddressItems[index].length"
                            class="mb-3"
                          ></NoRecordFound>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12" md="12">
                          <BaseELabel label="SSN Validation" class="mb-2" new-style />
                          <b-table
                            bordered
                            responsive
                            striped
                            :fields="ssnValidateFields"
                            :items="ssnValidateItems[index]"
                            :class="{
                              'mb-0': !ssnValidateItems[index].length,
                              'fraudReportHeaderTable': true,
                            }"
                            :options="options"
                          ></b-table>
                          <NoRecordFound
                            v-if="!ssnValidateItems[index].length"
                            class="mb-3"
                          ></NoRecordFound>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12" md="12">
                          <BaseELabel label="Name/Address/Phone Verification" class="mb-2" new-style />
                          <b-table
                            bordered
                            responsive
                            striped
                            :fields="namePhoneFields"
                            :items="namePhoneItems[index]"
                            :options="options"
                            :class="{
                              'mb-0': !namePhoneItems[index].length,
                              'fraudReportHeaderTable': true,
                            }"
                          >
                            <template v-slot:cell(isVerified)="data">
                              <span
                                :class="{
                                  'verifyStateN': data.item && data.item.isVerified && data.item.isVerified === 'N',
                                  'verifiedCell': true,
                                }"
                              >
                                {{ data.item.isVerified }}
                              </span>
                            </template>
                          </b-table>
                          <NoRecordFound
                            v-if="!namePhoneItems[index].length"
                            class="mb-3"
                          ></NoRecordFound>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12" md="12">
                          <BaseELabel label="Reverse Phone Number Lookup" class="mb-2" new-style />
                          <b-table
                            bordered
                            responsive
                            striped
                            :fields="dataLookupFields"
                            :items="dataLookupItems[index]"
                            :class="{
                              'mb-0': !dataLookupItems[index].length,
                              'fraudReportHeaderTable': true,
                            }"
                            :options="options"
                          ></b-table>
                          <NoRecordFound
                            v-if="!dataLookupItems[index].length"
                            class="mb-3"
                          ></NoRecordFound>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12" md="12">
                          <BaseELabel label="Reverse Address Lookup" class="mb-2" new-style />
                          <b-table
                            bordered
                            responsive
                            striped
                            :fields="usingAddressFields"
                            :items="usingAddressItems[index]"
                            :options="options"
                            :class="{
                              'mb-0': !usingAddressItems[index].length,
                              'fraudReportHeaderTable': true,
                            }"
                          ></b-table>
                          <NoRecordFound
                            v-if="!usingAddressItems[index].length"
                            class="mb-3"
                          ></NoRecordFound>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12" md="12">
                          <BaseELabel label="Surname Variants" class="mb-2" new-style />
                          <b-table
                            bordered
                            responsive
                            striped
                            :fields="sirNameVariantsFields"
                            :items="sirNameVariantsItems[index]"
                            :options="options"
                            :class="{
                              'mb-0': !sirNameVariantsItems[index].length,
                              'fraudReportHeaderTable': true,
                            }"
                          ></b-table>
                          <NoRecordFound
                            v-if="!sirNameVariantsItems[index].length"
                            class="mb-3"
                          ></NoRecordFound>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12">
                          <BaseELabel label="Date of Birth Verification" class="mb-2" new-style />
                          <b-table
                            bordered
                            responsive
                            striped
                            :items="dateOfBirthVerificationItems[index]"
                            :fields="dateOfBirthVerificationFields"
                            :options="options"
                            :class="{
                              'mb-0': !dateOfBirthVerificationItems[index].length,
                              'fraudReportHeaderTable': true,
                            }"
                          >
                            <template v-slot:cell(Verified)="data">
                              <span
                                v-if="data.item && data.item.Verified && data.item.Verified.split('(')[0].trim() === 'N'"
                                class="verifiedCell verifyStateN"
                              >
                                {{ data.item.Verified.split("(")[0] }}
                                <span class="font-weight-normal">&nbsp;{{ data.item.Verified.split("(")[1] ? '(' + data.item.Verified.split("(")[1] : '' }}</span>
                              </span>
                              <span v-else class="verifiedCell">{{ data.item.Verified }}</span>
                            </template>
                          </b-table>
                          <NoRecordFound
                            v-if="!dateOfBirthVerificationItems[index].length"
                            class="mb-3"
                          ></NoRecordFound>
                          <!-- <p class="text-right textRight"
                            ><strong class="pr-2 "> Confidence Level:</strong
                            >{{ confidenceLevel[index] }}</p
                          > -->
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12">
                          <BaseELabel label="Deceased Records" class="mb-2" new-style />
                          <b-table
                            bordered
                            responsive
                            striped
                            :items="deceasedRecordsItems[index]"
                            :fields="deceasedRecordsFields"
                            :options="options"
                            :class="{
                              'mb-0': !deceasedRecordsItems[index].length,
                              'fraudReportHeaderTable': true,
                            }"
                          ></b-table>
                          <NoRecordFound
                            v-if="!deceasedRecordsItems[index].length"
                            class="mb-3"
                          ></NoRecordFound>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <BaseELabel label="Address History Records" class="mb-2" new-style />
                          <b-table
                            bordered
                            responsive
                            striped
                            :items="addressHistoryRecordItems[index]"
                            :fields="addressHistoryRecordFields"
                            :options="options"
                            :class="{
                              'mb-0': !addressHistoryRecordItems[index].length,
                              'fraudReportHeaderTable': true,
                            }"
                          >
                          </b-table>
                          <NoRecordFound
                            v-if="!addressHistoryRecordItems[index].length"
                            class="mb-3"
                          ></NoRecordFound>
                        </b-col>
                      </b-row>
                    </div>
                    <CustomMessage v-else :custom-msg="customError[index].verifiedInfo"/>
                  </b-collapse>
                </div>
              </div>
            </div>
            <!-- AKA/s Aliases -->
            <div v-if="item.isShowPersonSearch" no-body class="mb-0 px-1 bg-white">
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle="`accordion-5${index}`"
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="item.isVisibleAliases = !item.isVisibleAliases"
                >
                  <p class="mb-0 text-dark font-weight-bold">AKAs/Aliases</p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${item.isVisibleAliases ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
                </div>
                <b-collapse :id="`accordion-5${index}`" visible>
                  <div v-if="customError[index].akas === null">
                    <b-row class="mt-2 pt-1 px-1">
                      <b-col sm="12" md="12">
                        <b-table
                          responsive
                          striped
                          bordered
                          :items="personSearchItems[index]"
                          :fields="personSearchFields"
                          :class="{
                            'mb-0': !personSearchItems[index].length,
                            'fraudReportHeaderTable': true,
                          }"
                        ></b-table>
                        <NoRecordFound
                          v-if="!personSearchItems[index].length"
                        ></NoRecordFound>
                      </b-col>
                    </b-row>
                  </div>
                  <CustomMessage v-else :custom-msg="customError[index].akas"/>
                </b-collapse>
            </div>
            <!-- Property Ownership Search -->
            <div v-if="item.ispropertyOwnership" no-body class="mb-1 p-1 bg-white">
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle="`accordion-8${index}`"
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="
                    item.isVisiblePropertyOwner = !item.isVisiblePropertyOwner
                    "
                >
                  <p class="mb-0 text-dark font-weight-bold">
                    Property Ownership Search ({{ propertyOwnershipData[index] ? propertyOwnershipData[index].length : 0 }})
                  </p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${item.isVisiblePropertyOwner ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
              <b-collapse :id="`accordion-8${index}`" visible>
                <div v-if="customError[index].propertyOwnership === null">
                  <b-row>
                    <b-col sm="12" md="12">
                      <propertyownership
                        :property-data="propertyOwnershipData[index]"
                        :borrower-id="index"
                      >
                      </propertyownership>
                    </b-col>
                  </b-row>
                </div>
                <CustomMessage v-else :custom-msg="customError[index].propertyOwnership"/>
              </b-collapse>
            </div>
            <!-- Associated Business Search -->
            <div
              v-if="item.isShowAccociatedBusiness"
              no-body
              class="bg-white p-1 mb-1"
            >
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle="`accordion-4${index}`"
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="
                    item.isVisibleAssociatedBusiness = !item.isVisibleAssociatedBusiness
                    "
                >
                  <p class="mb-0 text-dark font-weight-bold">
                    Associated Business Search ({{ asscociatedBusinessData[index] ? asscociatedBusinessData[index].length : 0 }})
                  </p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${item.isVisibleAssociatedBusiness ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
              <b-collapse :id="`accordion-4${index}`" visible>
                <div v-if="customError[index].associateBusiness === null">
                  <b-row>
                    <b-col sm="12" md="12">
                      <AssociatedBusinessFunctions
                        :associated-business="asscociatedBusinessData[index]"
                      ></AssociatedBusinessFunctions>
                    </b-col>
                  </b-row>
                </div>
                <CustomMessage v-else :custom-msg="customError[index].associateBusiness"/>
              </b-collapse>
            </div>
            <!-- NOD/Foreclosure -->
            <div v-if="item.isShowNodForeclosure" no-body class="mb-1 p-1 bg-white">
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle="`accordion-nod${index}`"
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="
                    item.isVisibleNodForeclosure = !item.isVisibleNodForeclosure
                    "
                >
                  <p class="mb-0 text-dark font-weight-bold">
                    NOD/Foreclosure ({{ nodForeclosureModelData[index].nodforeclosure ? nodForeclosureModelData[index].nodforeclosure.length : 0 }})
                  </p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${item.isVisibleNodForeclosure ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
                <b-collapse :id="`accordion-nod${index}`" visible>
                  <div v-if="customError[index].nod === null" class="px-1">
                    <propertyDetails
                      :property-data="nodForeclosureModelData[index]"
                    ></propertyDetails>
                  </div>
                  <CustomMessage v-else :custom-msg="customError[index].nod"/>
                </b-collapse>
            </div>
            <!-- Bankruptcy -->
            <div v-if="item.isShowBankruptcy" no-body class="mb-1 p-1 bg-white">
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle="`accordion-bankruptcy${index}`"
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="
                    item.isVisibleBankruptcy = !item.isVisibleBankruptcy
                    "
                >
                  <p class="mb-0 text-dark font-weight-bold">
                    Bankruptcy Filings ({{ bankruptcyData[index].length }})
                  </p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${item.isVisibleBankruptcy ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
                </div>
                <b-collapse :id="`accordion-bankruptcy${index}`" visible>
                  <div v-if="customError[index].bankruptcy === null">
                    <Bankruptcy :bankruptcy-details="bankruptcyData[index]"/>
                  </div>
                  <CustomMessage v-else :custom-msg="customError[index].bankruptcy"/>
                </b-collapse>
            </div>
            <!-- Professional Licenses -->
            <div v-if="item.isShowProfLicenses" no-body class="mb-1 p-1 bg-white">
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle="`accordion-profLicense${index}`"
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="
                    item.isVisibleProfLicenses = !item.isVisibleProfLicenses
                    "
                >
                  <p class="mb-0 text-dark font-weight-bold">
                    Professional Licenses ({{ profLicensesDetails[index].length }})
                  </p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${item.isVisibleProfLicenses ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
                </div>
                <b-collapse :id="`accordion-profLicense${index}`" visible>
                  <div v-if="customError[index].professionalLicense === null">
                    <ProfessionalLicenses :licenses-details="profLicensesDetails[index]" />
                  </div>
                  <CustomMessage v-else :custom-msg="customError[index].professionalLicense"/>
                </b-collapse>
            </div>
            <!-- Verification Of Occupancy -->
            <div v-if="item.isShowVOOSection" no-body class="mb-1 p-1 bg-white">
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle="`accordion-occupancy${index}`"
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="
                    item.isVisibleVOO = !item.isVisibleVOO
                    "
                >
                  <p class="mb-0 text-dark font-weight-bold">
                    Verification of Occupancy: Verification of Occupancy Score {{ vooScore[index] }}
                  </p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${item.isVisibleVOO ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
                </div>
                <b-collapse :id="`accordion-occupancy${index}`" visible>
                  <div v-if="customError[index].voo === null">
                    <VerificationofOccupancy :vo-details="verificationOccupancyDetails[index]" :gauge-id="`${index}`" />
                  </div>
                  <CustomMessage v-else :custom-msg="customError[index].voo"/>
                </b-collapse>
            </div>
            <!-- Relatives and Associates Search -->
            <div v-if="item.isShowRelatives" no-body class="mb-1 bg-white p-1">
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle="`accordion-associates${index}`"
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="item.isVisibleRelatives = !item.isVisibleRelatives"
                >
                  <p class="mb-0 text-dark font-weight-bold"
                    >Relatives and Associates Search</p
                  >
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${item.isVisibleRelatives ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
              <b-collapse :id="`accordion-associates${index}`" visible>
                <div v-if="customError[index].relativesAndAssociates === null">
                  <b-row>
                    <b-col sm="12" md="12">
                      <relativeAssociates
                        :relatives-data="relativesAndAssociates[index]"
                      ></relativeAssociates>
                    </b-col>
                  </b-row>
                </div>
                <CustomMessage v-else :custom-msg="customError[index].relativesAndAssociates"/>
              </b-collapse>
            </div>
            <!-- Driver's License Search -->
            <div v-if="item.isShowDriversInfo" no-body class="mb-1 p-1 bg-white">
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle="`accordion-7${index}`"
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="item.isVisibleDrivers = !item.isVisibleDrivers"
                >
                  <p class="mb-0 text-dark font-weight-bold">Driver's License Search</p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${item.isVisibleDrivers ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
              <b-collapse :id="`accordion-7${index}`" visible>
                <div v-if="customError[index].driversLicense === null">
                  <DriversLicenseSearch
                    :driver-information="driversLicenseData[index]"
                  />
                </div>
                <CustomMessage v-else :custom-msg="customError[index].driversLicense"/>
              </b-collapse>
            </div>
            <!-- Voter Registration Search -->
            <div v-if="item.isShowVoter" no-body class="mb-1 p-1 bg-white">
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle="`accordion-6${index}`"
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="item.isVisibleVoters = !item.isVisibleVoters"
                >
                  <p class="mb-0 text-dark font-weight-bold">Voter Registration Search</p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${item.isVisibleVoters ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
              <b-collapse :id="`accordion-6${index}`" visible>
                <div v-if="customError[index].voterRegistration === null">
                  <VoterRegistration :voter-information="voterObject[index]" />
                </div>
                <CustomMessage v-else :custom-msg="customError[index].voterRegistration"/>
              </b-collapse>
            </div>
            <!-- Employer Validation -->
            <div v-if="item.isShowEmployer" no-body class="mb-1 p-1 bg-white">
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle="`accordion-9${index}`"
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="item.isVisibleEmployer = !item.isVisibleEmployer"
                >
                  <p class="mb-0 text-dark font-weight-bold">Employer Validation</p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${item.isVisibleEmployer ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
              <b-collapse :id="`accordion-9${index}`" visible>
                <div v-if="customError[index].employerValidation === null">
                  <b-row>
                    <b-col sm="12" md="12">
                      <employerValidation
                        :borrower-id="index"
                        :employer-data="employerValidationData[index]"
                      ></employerValidation>
                    </b-col>
                  </b-row>
                </div>
                <CustomMessage v-else :custom-msg="customError[index].employerValidation"/>
              </b-collapse>
            </div>
            <!-- Liens and Judgments -->
            <div v-if="item.isShowLiens" no-body class="mb-1 p-1 bg-white">
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle="`accordion-3${index}`"
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="item.isVisibleLiens = !item.isVisibleLiens"
                >
                  <p class="mb-0 text-dark font-weight-bold">
                    Liens and Judgments ({{ liensAndJudgementsData[index] ? liensAndJudgementsData[index].length : 0 }})
                  </p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${item.isVisibleLiens ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
              <b-collapse :id="`accordion-3${index}`" visible>
                <div v-if="customError[index].liensAndJudge === null">
                  <b-row>
                    <b-col sm="12" md="12">
                      <liensAndJudgment
                        :liens-data="liensAndJudgementsData[index]"
                      ></liensAndJudgment>
                    </b-col>
                  </b-row>
                </div>
                <CustomMessage v-else :custom-msg="customError[index].liensAndJudge"/>
              </b-collapse>
            </div>
            <!-- UCC Filings -->
            <div v-if="item.isShowUCCDetails" no-body class="mb-1 p-1 bg-white">
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle="`accordion-ucc${index}`"
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="item.isVisibleUcc = !item.isVisibleUcc"
                >
                  <p class="mb-0 text-dark font-weight-bold">
                    UCC Filings ({{ uccDetails[index].length }})
                  </p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${item.isVisibleUcc ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
              <b-collapse :id="`accordion-ucc${index}`" visible>
                <div v-if="customError[index].uccDetail === null">
                  <UccFilings :ucc-details="uccDetails[index]"/>
                </div>
                <CustomMessage v-else :custom-msg="customError[index].uccDetail"/>
              </b-collapse>
            </div>
            <!-- Criminal Records Report section -->
            <div v-if="item.isShowCriminalRecords" no-body class="mb-1 p-1 bg-white">
              <CriminalRecords :criminal-data="criminalData[index]" :collapsible-id="`criminalCollapsible${index}`"
              :criminal-error="customError[index].criminalRecord">
              </CriminalRecords>
            </div>
            <!-- Sexual Offenses section -->
            <div v-if="item.isShowSODetails" no-body class="mb-1 p-1 bg-white">
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle="`accordion-offences${index}`"
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="item.isVisibleOffenses = !item.isVisibleOffenses"
                >
                  <p class="mb-0 text-dark font-weight-bold">
                    Sexual Offenses ({{ sexualOffenceDetails[index].length }})
                  </p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${item.isVisibleOffenses ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
              <b-collapse :id="`accordion-offences${index}`" visible>
                <div v-if="customError[index].sexualOffense === null">
                  <SexualOffences :so-details="sexualOffenceDetails[index]" />
                </div>
                <CustomMessage v-else :custom-msg="customError[index].sexualOffense"/>
              </b-collapse>
            </div>
            <!-- Borrower PHS -->
            <div v-if="item.isShowPropertyHistory">
              <PropertyHistorySearch
                :report-type="`PHSborrower${index}`"
                :property-history="borrowerPHSData[index]"
                :phs-message="customError[index].phs"
              />
            </div>
            <!-- <div v-if="isShowBorrowerWatchlist" class="mb-4">
                <b-row class="my-3">
                  <b-col class="mx-2">
                    <BaseELabel class="my-1" label="Result" />
                    <div
                      v-if="
                        borowerResultItems[index].length ||
                          !borrowerApiSuccess[index]
                      "
                    >
                      <b-table
                        responsive
                        striped
                        bordered
                        :fields="borrowerResultFields"
                        :items="borowerResultItems[index]"
                        :class="{ 'mb-0': !borowerResultItems[index].length }"
                      >
                        <template v-slot:cell(SearchResults)="rowitem">
                          <div :class="$style.reasonStyle">
                            <div>Reason: {{ rowitem.item.Reason }}</div>
                            <div>Address: {{ rowitem.item.Address }}</div>
                          </div>
                        </template>
                        <template v-slot:cell(action)="rowitem">
                          <BaseIcon
                            v-if="rowitem.item.action === 'Active'"
                            :class="$style.statusSuccess"
                            size="lg"
                            name="check"
                          />
                          <BaseIcon
                            v-else
                            :class="$style.statusFail"
                            size="lg"
                            name="times"
                          />
                        </template>
                      </b-table>
                      <NoRecordFound
                        v-if="!borowerResultItems[index].length"
                      ></NoRecordFound>
                    </div>
                  </b-col>
                </b-row>
                <NoTriggerFound
                  v-if="isShowBorrowerWatchlist && borrowerApiSuccess[index]"
                  :display-message="
                    borowerResultItems[index].length ? false : true
                  "
                />
              </div> -->
            <!-- Borrower MERS -->
            <div v-if="item.isshowMERS">
              <MERS
                mers-label="SSN"
                :report-type="`borrower${index}`"
                :mers-response="mersResponse[index]"
            /></div>
          </b-collapse>
        </div>
        <!-- </VueHtmlAsPdf> -->
      </div>
    </div>
    <!-- ========== Borrower section ends ============-->

    <!-- ========== Borrower and Employer Watchlist section starts ==========-->
    <div v-if="isShowBorrowerAndEmployerWatchlist" id="borrowerAndEmployerWatchlist">
      <div no-body class="mb-1 p-1 bg-white">
        <div header-tag="header" class="p-1" role="tab">
          <b-button
            v-b-toggle="`collapse-borrowerAndEmployerWatchlist`"
            block
            class="d-flex collapseStyle"
            :class="$style.nooutline"
            @click="isBorrowerAndEmployerWatchlistCollapsed = !isBorrowerAndEmployerWatchlistCollapsed"
          >
            <p class="mb-0"><b>Borrower and Employer Watchlist</b></p>
            <strong class="ml-auto"
              ><i
                :class="`fa fa-angle-${isBorrowerAndEmployerWatchlistCollapsed ? 'up' : 'down'
                  } text-white`
                  "
              ></i
            ></strong>
          </b-button>
        </div>
        <b-collapse :id="`collapse-borrowerAndEmployerWatchlist`" visible>
          <b-row class="p-2">
            <b-col class="d-flex justify-content-end">
              <div class="p-2 d-flex">
                <img src="@assets/images/print-icon.svg" class="pr-2"/>
                <b-link class="fraudReportPrintLink" @click="getFrXPDFFromAPI('borroweremployerdetails')">Print Section</b-link>
              </div>
            </b-col>
          </b-row>
          
          <div>
            <b-row :class="{
                    'mb-3': !borrowersAndEmployersRiskItems.length,
                  }">
              <b-col class="mx-2">
                <BaseELabel label="Findings" new-style />
                <!--TODO: Add logic to borrowerAndEmployerError handle -->
                <RiskIndicators
                  class="mt-2"
                  :risk-indicators="borrowersAndEmployersRiskItems"
                  :risk-error="borrowerAndEmployerError"
                  :read-only="isReadOnly"
                  @addupdated="updatedcomments"
                />
              </b-col>
            </b-row>
            <WatchlistDetails 
              :watchlist-table-header-name="'Borrower and Employer'"
              :watchlist-error="borrowerAndEmployerError"
              :watchlist-items="borrowersAndEmployersItems"
              :result-items="borrowersAndEmployersResultItems"
              :show-pep-column="isShowPepColumn"
            />
          </div>
        </b-collapse>
      </div>
    </div>
    <!-- ========== Borrower and Employer Watchlist section ends ============-->

    <!-- ========== Property section starts ==========-->
    <div v-if="showPropertySection && !isBatchOrder" id="propertydetails">
      <!-- <VueHtmlAsPdf ref="propertydetails" reference="propertydetails"> -->
      <div no-body class="mb-1 p-1 bg-white">
        <div header-tag="header" class="p-1" role="tab">
          <b-button
            v-b-toggle="`collapse-property`"
            block
            class="d-flex collapseStyle"
            :class="$style.nooutline"
            @click="isPropertyCollapsed = !isPropertyCollapsed"
          >
            <p class="mb-0"
              ><b
                ><span>Property Detail Report</span>
                <span> - {{ propertyFinding }}</span></b
              ></p
            >
            <strong class="ml-auto"
              ><i
                :class="`fa fa-angle-${isPropertyCollapsed ? 'up' : 'down'
                  } text-white`
                  "
              ></i
            ></strong>
          </b-button>
        </div>
        <b-collapse :id="`collapse-property`" visible>
          <b-row class="p-2">
            <b-col class="p-0 d-flex justify-content-end">
              <div class="d-flex printReportCustom">
                <img src="@assets/images/print-icon.svg" class="pr-2"/>
                <b-link class="fraudReportPrintLink" @click="getFrXPDFFromAPI('propertydetails')">Print Section</b-link>
              </div>
            </b-col>
          </b-row>
          <div :class="$style.borrowerReport" class="mb-3">
            <BaseELabel label="Property Type: Subject Property" new-style />
            <RiskIndicators
              class="my-2"
              :risk-indicators="propertyRiskItems"
              :risk-error="propertyErrorMsg.propertyRisk"
              :read-only="isReadOnly"
              @addupdated="updatedcomments"
            />
          </div>
          <!-- Distance Estimation -->
          <div v-if="isShowDistanceEstimation">
            <div
              class="border my-3"
              role="tablist"
            >
              <div no-body class="my-1 bg-white">
                <div header-tag="header" class="p-1" role="tab">
                  <b-button
                    v-b-toggle="`accordion-dist`"
                    block
                    class="d-flex collapseHeadStyle"
                    :class="$style.nooutline"
                    @click="isVisibleDistance = !isVisibleDistance"
                  >
                    <p class="mb-0 text-dark font-weight-bold"
                      >Distance Estimation</p
                    >
                    <strong class="ml-auto"
                      ><i
                        :class="`fa fa-angle-${isVisibleDistance ? 'up' : 'down'
                          } text-dark`
                          "
                      ></i
                    ></strong>
                  </b-button>
                </div>
                <b-collapse :id="`accordion-dist`" visible>
                  <div v-for="(item, i) in googleDistanceData"
                      :key="i" header-tag="header" class="p-2" role="tab">
                    <b-button
                      v-b-toggle="`accordion-distborrower${i}`"
                      block
                      class="d-flex collapseSubHeader"
                      :class="$style.nooutline"
                      @click="item.isVisibleDBorrower = !item.isVisibleDBorrower"
                    >
                      <p class="text-dark font-weight-bolder mb-0">{{ item.borrowerName }}</p>
                      <strong class="ml-auto"
                        ><i
                          :class="`fa fa-angle-${item.isVisibleDBorrower ? 'up' : 'down'
                            } text-dark`
                            "
                        ></i
                      ></strong>
                    </b-button>
                    <b-collapse :id="`accordion-distborrower${i}`" visible>
                  <div class="mx-1">
                    <b-row>
                      <b-col
                        cols="12"
                        class="mt-2"
                        :class="$style.overflowInitial"
                      >
                        <b-table
                          bordered
                          responsive
                          striped
                          :fields="distanceEstimationFields"
                          :items="item.distanceEstimationItems"
                          :options="options"
                          :class="{
                            'mb-0': !item.distanceEstimationItems.length,
                            'fraudReportHeaderTable': true,
                          }"
                        >
                        </b-table>
                        <NoRecordFound
                          v-if="!item.distanceEstimationItems.length"
                        ></NoRecordFound>
                      </b-col>
                    </b-row>
                  </div>
                  </b-collapse>
                  </div>
                </b-collapse> </div
            ></div>
          </div>

          <div role="tablist">
            <!-- APR Subject Valuation -->
            <div
              v-if="isShowSubjectValuation"
              no-body
              class="my-1 p-1 bg-white"
            >
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle.accordion-10
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="isSubjectValuation = !isSubjectValuation"
                >
                  <p class="mb-0 text-dark font-weight-bolder">Abbreviated Property Report</p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${isSubjectValuation ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
              <b-collapse id="accordion-10" visible>
                <div v-if="displaySubValuation && propertyErrorMsg.apr === null" class="mx-1 ">
                  <b-row>
                    <b-col
                      cols="12"
                      class="mt-1"
                      :class="$style.overflowInitial"
                    >
                      <b-row class="mx-1">
                        <BaseELabel
                          :label="`Property Address : ${subjectValuationAddress}`"
                          new-style
                        />
                        <BaseELabel
                          class="ml-2"
                          :label="subjectValuationCoordinates"
                          new-style
                        />
                      </b-row>
                      <div class="my-2 mx-1">
                        <b-table
                          bordered
                          responsive
                          striped
                          :fields="SubjectValuationFields"
                          :items="SubjectValuationItems"
                          :options="options"
                          class="mb-0 fraudReportHeaderTable"
                        >
                        </b-table>
                        <NoRecordFound
                          v-if="!Object.values(SubjectValuationItems[0]).some(
                            (x) => x !== null && x !== ''
                          )
                          "
                        />
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <CustomMessage v-else :custom-msg="propertyErrorMsg.apr"/>
              </b-collapse>
            </div>
            <!-- IPR Subject Valuation -->
            <div
              v-if="isShowIprSubjectValuation"
              no-body
              class="my-1 p-1 bg-white"
            >
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle.accordion-17
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="isIprSubjectValuation = !isIprSubjectValuation"
                >
                  <p class="mb-0 text-dark font-weight-bolder">Expanded Property Report</p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${isIprSubjectValuation ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
              <b-collapse id="accordion-17" visible>
              <div v-if="propertyErrorMsg.epr === null">
                <div v-if="displayIprSubValuation" class="mx-1 ">
                  <b-row>
                    <b-col
                      cols="12"
                      class="mt-1"
                      :class="$style.overflowInitial"
                    >
                      <b-row class="mx-1">
                        <BaseELabel
                          :label="`Property Address : ${iprSubjectValuationAddress}`"
                          new-style
                        />
                        <BaseELabel
                          class="ml-2"
                          :label="iprSubjectValuationCoordinates"
                          new-style
                        />
                      </b-row>
                      <div class="my-2 mx-1">
                        <b-table
                          bordered
                          responsive
                          striped
                          :fields="iprSubjectValuationFields"
                          :items="iprSubjectValuationItems"
                          :options="options"
                          class="mb-0 fraudReportHeaderTable"
                        >
                        </b-table>
                        <NoRecordFound
                          v-if="!Object.values(iprSubjectValuationItems[0]).some(
                            (x) => x !== null && x !== ''
                          )
                          "
                        />
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <!-- Area Market Analysis -->
                <div v-if="displayIprReport" no-body class="mb-1 p-1 bg-white">
                  <div header-tag="header" class="p-1" role="tab">
                    <b-button
                      v-b-toggle.accordion-12
                      block
                      class="d-flex collapseSubHeader"
                      :class="$style.nooutline"
                      @click="
                        isVisibleAreaMarketAnalysis = !isVisibleAreaMarketAnalysis
                        "
                    >
                      <p class="text-dark font-weight-bolder mb-0">Area Market Analysis</p>
                      <strong class="ml-auto"
                        ><i
                          :class="`fa fa-angle-${isVisibleAreaMarketAnalysis ? 'up' : 'down'
                            } text-dark`
                            "
                        ></i
                      ></strong>
                    </b-button>
                  </div>
                  <b-collapse id="accordion-12" visible>
                    <div>
                      <b-row>
                        <b-col>
                          <div v-if="showIprSection">
                            <b-row class="mx-1 mt-1"
                              ><BaseELabel
                                label="*Based upon DSF type properties in the subject's neighborhood area over the previous 1 year"
                                new-style
                            /></b-row>
                            <b-row class="px-1 pt-1">
                              <b-col
                                ><BaseELabel
                                  :label="`Total Property Count : ${formatDisplay(
                                    totalPropertyCount
                                  )}`
                                    "
                              /></b-col>
                              <b-col
                                ><BaseELabel
                                  :label="`Property Sales Count : ${formatDisplay(
                                    propertySalesCount
                                  )}`
                                    "
                              /></b-col>
                              <b-col
                                ><BaseELabel
                                  :label="`Percent Non-Owner Occupied : ${percentNonOwnerOccupied}`
                                    "
                              /></b-col>
                            </b-row>
                            <b-row class="mx-1">
                              <b-table
                                responsive
                                striped
                                bordered
                                :fields="areaMarketAnalysisFields"
                                :items="areaMarketAnalysisItems"
                                class="fraudReportHeaderTable"
                              >
                              </b-table>
                            </b-row>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>
                </div>
                <!-- HPI Overview -->
                <div v-if="displayIprReport" no-body class="mb-1 p-1 bg-white">
                  <div header-tag="header" class="p-1" role="tab">
                    <b-button
                      v-b-toggle.accordion-13
                      block
                      class="d-flex collapseSubHeader"
                      :class="$style.nooutline"
                      @click="isVisibleHpiOverview = !isVisibleHpiOverview"
                    >
                      <p class="text-dark font-weight-bolder mb-0">HPI Overview</p>
                      <strong class="ml-auto"
                        ><i
                          :class="`fa fa-angle-${isVisibleHpiOverview ? 'up' : 'down'
                            } text-dark`
                            "
                        ></i
                      ></strong>
                    </b-button>
                  </div>
                  <b-collapse id="accordion-13" visible>
                    <div>
                      <b-row>
                        <b-col>
                          <div v-if="showIprSection">
                            <div
                              v-if="hpiOverviewImage !== null"
                              class="text-center my-3"
                            >
                              <b-img
                                :src="`data:image/png;base64,${hpiOverviewImage}`
                                  "
                              ></b-img>
                            </div>
                            <div
                              v-else
                              class="mx-1 py-1 text-center font-weight-bold"
                              :class="$style.noRecord"
                              >No Data</div
                            >
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>
                </div>
                <!-- Comparables Matrix -->
                <div v-if="displayIprReport" no-body class="mb-1 p-1 bg-white">
                  <div header-tag="header" class="p-1" role="tab">
                    <b-button
                      v-b-toggle.accordion-16
                      block
                      class="d-flex collapseSubHeader"
                      :class="$style.nooutline"
                      @click="
                        isVisibleComparablesMatrix = !isVisibleComparablesMatrix
                        "
                    >
                      <p class="text-dark font-weight-bolder mb-0">Comparables Matrix</p>
                      <strong class="ml-auto"
                        ><i
                          :class="`fa fa-angle-${isVisibleComparablesMatrix ? 'up' : 'down'
                            } text-dark`
                            "
                        ></i
                      ></strong>
                    </b-button>
                  </div>
                  <b-collapse id="accordion-16" visible>
                    <div>
                      <b-row>
                        <b-col>
                          <div v-if="showIprSection">
                            <div
                              v-if="comparablesMatrixImage !== null"
                              class="text-center my-3"
                            >
                              <b-img
                                :src="`data:image/png;base64,${comparablesMatrixImage}`
                                  "
                              ></b-img>
                            </div>
                            <div
                              v-else
                              class="mx-1 py-1 text-center text-danger font-weight-bold"
                              :class="$style.noRecord"
                              >Comparable Image not available</div
                            >
                            <div class="mx-1 mt-3">
                              <ComparablesMatrixTable
                                :property-table-data="comparablesMatrixData"
                              />
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>
                </div>
              </div>
              <CustomMessage v-else :custom-msg="propertyErrorMsg.epr"/>
              </b-collapse>
            </div>
            <!-- Housing Price Index -->
            <div v-if="isShowHousePriceIndex" no-body class="mb-1 p-1 bg-white">
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle.accordion-14
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="isVisibleHousePriceIndex = !isVisibleHousePriceIndex"
                >
                  <p class="mb-0 text-dark font-weight-bolder">Housing Price Index</p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${isVisibleHousePriceIndex ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
              <b-collapse id="accordion-14" visible>
                <div>
                  <b-row v-if="noHpiData">
                    <b-col>
                      <div v-if="displayHpiSection && propertyErrorMsg.hpi === null">
                        <div class="mx-1 my-3">
                          <HousePriceIndexTable
                            :house-price-index-data="housePriceIndexData"
                          />
                        </div>
                        <div class="ml-2 py-3" :class="$style.textFont">
                          <b-row class="my-2">
                            <b-col md="3">
                              <div><b>Quarter Scoring Indicator (Volatility):</b></div>
                            </b-col>
                            <b-col md="auto" class="text-center">
                              <div v-if="hpiPercentileValues.quarterPercentile"
                                >{{ formatHpiValues(hpiPercentileValues.quarterPercentile) + '%'
                                }}<b-img
                                  :src="getArrow(hpiPercentileValues.quarterPercentile)"
                                  class="arrowSize"
                              /></div>
                            </b-col>
                            <b-col class="text-dark">
                              <div><p>{{ FraudXHpiText.qtrScoreText }}</p></div>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col md="3">
                              <div ><b>Year Scoring Indicator (Volatility):</b></div>
                            </b-col>
                            <b-col md="auto" class="text-center">
                              <div v-if="hpiPercentileValues.yearPercentile"
                                >{{ formatHpiValues(hpiPercentileValues.yearPercentile) + '%'
                                }}<b-img
                                  :src="getArrow(hpiPercentileValues.yearPercentile)"
                                  class="arrowSize"
                              /></div>
                            </b-col>
                            <b-col class="text-dark">
                              <div><p >{{ FraudXHpiText.yearScoreText }}</p></div>
                            </b-col>
                          </b-row>
                        </div>
                      </div>
                      <CustomMessage v-else :custom-msg="propertyErrorMsg.hpi"/>
                    </b-col>
                  </b-row>
                  <NoRecordFound v-else class="mx-1" />
                </div>
              </b-collapse>
            </div>
            <!-- Competitive Market Climate -->
            <div
              v-if="isshowCompetitiveMarket"
              no-body
              class="mb-1 p-1 bg-white"
            >
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle.accordion-15
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="
                    isVisibleCompMarketClimate = !isVisibleCompMarketClimate
                    "
                >
                  <p class="mb-0 text-dark font-weight-bolder">Competitive Market Climate</p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${isVisibleCompMarketClimate ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
              <b-collapse id="accordion-15" visible>
                <div>
                  <b-row>
                    <b-col>
                      <div v-if="displayCmcSection && propertyErrorMsg.cmc === null">
                        <div class="mx-1 my-2">
                          <BaseELabel
                            label="Within Subject's Neighborhood/Segment - Same Property Type" new-style
                          />
                          <CompetitiveMarketClimate
                            :climate-data="cmcSegmentResponseModel"
                          />
                        </div>
                        <div class="mx-1 my-3">
                          <BaseELabel
                            :label="`Within Subject's Zip Code (${cmcZipVal}) - Same Property Type`
                              "
                            new-style
                          />
                          <CompetitiveMarketClimate
                            :climate-data="cmcZipCodeResponseModel"
                          />
                        </div>
                      </div>
                      <CustomMessage v-else :custom-msg="propertyErrorMsg.cmc"/>
                    </b-col>
                  </b-row>
                </div>
              </b-collapse>
            </div>
            <!-- ARS -->
            <div v-if="isShowAreaRecentSales" no-body class="mb-1 p-1 bg-white">
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle.accordion-11
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="isVisibleAreaRecentSales = !isVisibleAreaRecentSales"
                >
                  <p class="mb-0 text-dark font-weight-bolder">Area Recent Sales</p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${isVisibleAreaRecentSales ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
              <b-collapse id="accordion-11" visible>
                <div>
                  <b-row>
                    <b-col>
                      <div v-if="arsErrorMessage === null && propertyErrorMsg.ars === null">
                        <div v-if="showARSData">
                          <div
                            v-if="areaRecentGraph !== null"
                            class="text-center my-4"
                          >
                            <b-img
                              :src="`data:image/png;base64,${areaRecentGraph}`"
                            ></b-img>
                          </div>
                          <div
                            v-else
                            class="mx-1 py-1 mt-2 text-center text-danger font-weight-bold"
                            :class="$style.noRecord"
                            >Area Recent Sales graph not available</div
                          >
                        </div>
                        <div
                          v-else
                          class="mx-1 py-1 text-center text-danger font-weight-bold"
                          :class="$style.noRecord"
                          >*** No recent sales data found ***</div
                        >

                        <div class="mx-1">
                          <AreaRecentSalesDetails :ars-details="arsDetails" />
                        </div>

                        <div v-if="showARSData">
                          <b-row class="mx-1 mt-3">
                            <b-col class="bg-light d-flex">
                              <div class="mr-4"><BaseELabel size="md" label="Sales Summary -" /></div>
                              <div class="mx-4"><BaseELabel :label="`Low : ${formatDisplay(arsSummaryData.low)}`" /></div>
                              <div class="mx-4"><BaseELabel :label="`Average : ${formatDisplay(arsSummaryData.average)}`" /></div>
                              <div class="mx-4"><BaseELabel :label="`High : ${formatDisplay(arsSummaryData.high)}`" /></div>
                              <div class="mx-4"><BaseELabel :label="`Median : ${formatDisplay(arsSummaryData.median)}`" /></div>
                            </b-col>
                          </b-row>
                          <div class="mx-1">
                            <b-table
                              responsive
                              striped
                              bordered
                              no-local-sorting
                              class="mb-0 fraudReportHeaderTable"
                              :fields="areaRecentSalesFields"
                              :items="areaRecentSalesItems"
                              @sort-changed="arsSortingChanged"
                            >
                            </b-table>
                            <NoRecordFound
                              v-if="!areaRecentSalesItems.length"
                            />
                          </div>
                        </div>
                        <div
                          v-else
                          class="mx-1 py-1 text-center text-danger font-weight-bold"
                          :class="$style.noRecord"
                          >*** No recent sales data found ***</div
                        >
                      </div>
                      <CustomMessage v-else :custom-msg="propertyErrorMsg.ars"/>
                    </b-col>
                  </b-row>
                </div>
              </b-collapse>
            </div>
            <!-- CA Value AVM -->
            <div v-if="isshowAvm" no-body class="mb-1 p-1 bg-white">
              <div header-tag="header" class="p-1" role="tab">
                <b-button
                  v-b-toggle.CAvalueAVM
                  block
                  class="d-flex collapseHeadStyle"
                  :class="$style.nooutline"
                  @click="
                    isVisibleComparablesMatrix = !isVisibleComparablesMatrix
                    "
                >
                  <p class="mb-0 text-dark font-weight-bolder"> CA Value AVM</p>
                  <strong class="ml-auto"
                    ><i
                      :class="`fa fa-angle-${isVisibleComparablesMatrix ? 'up' : 'down'
                        } text-dark`
                        "
                    ></i
                  ></strong>
                </b-button>
              </div>
              <b-collapse id="CAvalueAVM" visible>
                <div v-if="propertyErrorMsg.avm === null">
                   <CustomMessage v-if="avmCustomMessage" :custom-msg="avmCustomMessage"/>
                  <Avm :avm-response="AVMData"/>
                </div>
                <CustomMessage v-else :custom-msg="propertyErrorMsg.avm"/>

              </b-collapse>
            </div>
            <!-- FEMA Disaster List -->
            <div v-if="isShowFEMA">
              <FEMADisasterList :fema-data="femaData" :fema-message="propertyErrorMsg.fema" />
            </div>
            <!-- Property MERS -->
            <div v-if="isShowPropertyMERS">
              <MERS
                mers-label="Address"
                report-type="property"
                :mers-response="propertyMersResponse"
            /></div>
            <!-- Property PHS -->
            <div v-if="isshowPropertyPHSData">
              <PropertyHistorySearch
                report-type="PHSproperty"
                :property-history="propertyPHSData"
                :phs-message="propertyErrorMsg.phs"
              />
            </div>
          </div>
        </b-collapse>
      </div>
      <!-- </VueHtmlAsPdf> -->
    </div>
    <!-- ========== Property section ends ========== -->
    <!-- ========== Participant section starts ========== -->
    <div v-if="isShowParticipantReport" id="participantdetails">
      <div no-body class="mb-1 p-1 bg-white">
        <div header-tag="header" class="p-1" role="tab">
          <b-button
            v-b-toggle="`collapse-participant-report`"
            block
            class="d-flex collapseStyle"
            :class="$style.nooutline"
            @click="isParticipantReportCollapsed = !isParticipantReportCollapsed"
          >
            <p class="mb-0"><b>Participant Detail Report</b></p>
            <strong class="ml-auto"
              ><i
                :class="`fa fa-angle-${isParticipantReportCollapsed ? 'up' : 'down'
                  } text-white`
                  "
              ></i
            ></strong>
          </b-button>
        </div>
        <b-collapse :id="`collapse-participant-report`" visible>
          <b-row class="p-2">
            <b-col class="d-flex justify-content-end">
              <div class="p-2 d-flex">
                <img src="@assets/images/print-icon.svg" class="pr-2"/>
                <b-link class="fraudReportPrintLink" @click="getFrXPDFFromAPI('participantdetails')">Print Section</b-link>
              </div>
            </b-col>
          </b-row>
          <div>
            <b-row :class="{
                    'mb-3': !participantRiskItems.length,
                  }">
              <b-col class="mx-2">
                <BaseELabel label="Findings" new-style />
                <!--TODO: Add logic to participantError handle -->
                <RiskIndicators
                  class="mt-2"
                  :risk-indicators="participantRiskItems"
                  :risk-error="participantError"
                  :read-only="isReadOnly"
                  @addupdated="updatedcomments"
                />
              </b-col>
            </b-row>
            <WatchlistDetails 
              :watchlist-table-header-name="'Participant'"
              :watchlist-error="participantError"
              :watchlist-items="participantItems"
              :result-items="participantResultItems"
              :is-batch-order="isBatchOrder"
            />
            <b-row>
              <b-col 
                class="mx-2" 
                :class="{
                    'mt-3': !participantResultItems.length,
                  }">
                <div class="d-flex justify-content-between mt-1 mb-2">
                  <BaseELabel label="License Verifications" new-style />
                  <div class="d-flex watchlistActionsContainer">
                    <div class="watchlistAction">
                      <img src="@assets/images/check-icon.svg"/>
                      <span>No action required</span>
                    </div>
                    <div class="watchlistAction">
                      <img src="@assets/images/warning-icon.svg"/>
                      <span>Action required</span>
                    </div>
                    <div class="watchlistAction">
                      <img src="@assets/images/remove-icon.svg"/>
                      <span>Not applicable</span>
                    </div>
                    <div class="watchlistAction">
                      <img src="@assets/images/lock-icon.svg"/>
                      <span>Not enabled</span>
                    </div>
                  </div>
                </div>
                <b-table
                  responsive
                  striped
                  bordered
                  :fields="filteredLicenseVerificationsFields"
                  :items="licenseVerificationsItems"
                  :class="{
                    'mb-0': !licenseVerificationsItems.length,
                    'watchlistTable': true,
                    'fraudReportHeaderTable': true,
                  }"
                >
                  <template v-slot:cell(Name)="row">
                    <div class="d-flex flex-column">
                      <span class="px-2 pt-2 pb-1 roleTitleWatchlistTable">{{ row.item.Role }}</span>
                      <span class="px-2 pb-2">{{ row.item.Name }}</span>
                    </div>
                  </template>
                  <template
                      v-for="(entity, ind) in licenseTableItems"
                      v-slot:[getCell(entity)]="row"
                    >
                    <div :key="ind" class="watchlistTableIconContainer" :class="{ 'watchlistTableWarningIconContainer': row.item[entity] === 1 }">
                        <span v-if="row.item[entity] === -1" >
                          <img src="@assets/images/lock-icon.svg"/>
                        </span>
                        <span v-else-if="row.item[entity] === 1" >
                          <img src="@assets/images/warning-icon.svg"/>
                        </span>
                        <span v-else-if="row.item[entity] === null">
                          <img src="@assets/images/remove-icon.svg"/>
                        </span>
                        <span v-else-if="row.item[entity] === 0">
                          <img src="@assets/images/check-icon.svg"/>
                        </span>
                    </div>
                  </template>
                  <template v-slot:cell(Entitytype)="row">
                    <div class="p-2">{{ row.item.Entitytype }}</div>
                  </template>
                  <template v-slot:cell(LicenseNumber)="row">
                    <div class="p-2">{{ row.item.LicenseNumber }}</div>
                  </template>
                  <template v-slot:cell(Result)="row">
                    <div class="licenseVerificationsResultContainer py-2 pl-2 pr-4">
                      <div v-for="(item, index) in row.item.Result" :key="index">
                        <div v-if="item && item.nmls">
                          <div v-if="item.nmls.license">
                            Name: {{ item.name }} | 
                            License Number: 
                            <span v-if="item.nmls.license.licenseNumber">{{ item.nmls.license.licenseNumber }}</span>
                            <span v-else>No record found</span> |
                            License Type: {{ item.nmls.license.licenseType }} |
                            Issue Date: {{ formatDate(item.nmls.license.issueDate) }} | 
                            Status: {{ item.nmls.license.status }} | 
                            Regulator: {{ item.nmls.license.regulator}}
                          </div>
                          <div v-else>
                            License: No record found
                          </div>
                          <div v-if="row.item.Role !== 'Lender'">
                            <div v-if="item.nmls.disciplinaryActions && item.nmls.disciplinaryActions.length > 0">
                              <div v-for="action of item.nmls.disciplinaryActions" :key="action.disciplinaryActionId">
                                Disciplinary Action: 
                                Authority Type: {{ action.authorityType }} | 
                                Authority: {{ action.nameOfAuthority }} |
                                Date: {{ formatDate(action.dateOfAction) }} | 
                                Document: <a :href='action.associatedDocumentUrl'>Link to document</a>
                              </div>
                            </div>
                            <div v-else>
                              Disciplinary Action: No record found
                            </div>
                          </div>
                        </div>
                        <div v-else-if="item && item.appraiser">
                          <div>
                            Name: {{ item.name }} | 
                            Status: {{ item.appraiser.status }} |
                            Expiration Date: {{ formatDate(item.appraiser.expirationDate) }} | 
                            License Number: {{ item.appraiser.licenseNumber }} | 
                            Phone: {{ item.appraiser.phone }}
                           </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </b-table>
                <NoRecordFound v-if="!licenseVerificationsItems.length"></NoRecordFound>
              </b-col>
            </b-row>
          </div>
        </b-collapse>
      </div>
    </div> 
    <!-- ========== Participant section ends ========== -->

    <!-- <div v-if="isShowAppendix" class="mt-3">
      <VueHtmlAsPdf ref="appendixSection" reference="appendixSection">
        <b-row>
          <b-col cols="12" md="auto">
            <h4 class="pt-2 pl-2" :class="$style.sideHeading"
              >APPENDIX</h4
            ></b-col
          >
          <b-col class="pt-3">
            <b-link @click="printpdf('appendixSection')"
              >(Print Section)</b-link
            >
          </b-col>
        </b-row>
        <div class="mx-2">
          <AppendixWatchlists />
        </div>
      </VueHtmlAsPdf>
    </div> -->
    <div id="frxFooter" class="pt-5">
      <b-row class="pb-5 baseContentFont">
        <b-col
          ><p class="text-justify px-2">{{ fraudXFooterData }}</p></b-col
        >
      </b-row>
      <b-row class="font-weight-bold text-center mt-5 pt-5"
        ><b-col>*** END OF REPORT {{ currentDateTime }} ***</b-col></b-row
      >
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.blueHeader {
  height: 60px;
  background-color: $color-dark-purple;
}

.logoBorderLeft {
  height: 80px;
  border-left: 4px solid $color-dark-purple;
}

.logopadding {
  width: 400px;
  padding-top: 13px;
  padding-left: 100px;
}

.bgGrey {
  padding: 16px;
  margin-bottom: 24px;
  background-color: #E9ECEF;
  border-radius: 4px;
}

.textFont {
  font-size: $size-content-font;
}

.formImage {
  width: 300px;
}

.fxImage {
  width: 330px;
}

.color {
  background-color: orange;
  border: 1px solid black;
}

.label {
  margin: 0.5rem 0;
  color: $color-text-gray;
}

.description {
  font-size: 10px !important;
  font-weight: 500;
  color: $color-link-text;
}

.loanInfo {
  width: 100%;
  background: #fff;

  th,
  td {
    padding: 0.3rem;
    text-align: left !important;
    border: 1px solid #dee2e6;
  }
}

.loanInfo th {
  font-size: 0.8125rem;
  font-weight: normal;
  color: #fff;
  background-color: #00264c;
}

.loanInfo tr:nth-child(odd) {
  background-color: #f2f2f2;
}

.reportInfoHead {
  margin: auto;
  background: #491e7a;
  border-radius: 4px 4px 0 0;
}

.borrowerReport {
  padding: 10px;
  background: #fff;
  border: 1px solid #fcfcfc;
}

.borrowerReport h5 {
  font-weight: bold;
  color: #f4a20d;
}

.status {
  margin: 0.625rem 0;
  font-size: $size-content-font;
  font-weight: $label-font-weight;
  color: $color-text-gray;
}

.overflowInitial {
  overflow: initial;
}

.sideHeading {
  font-weight: bold !important;
}

.noRecord {
  font-size: $size-content-font;
  border: 1px solid #dee2e6;
}

.statusSuccess {
  width: 10px;
  height: 8.5px;
  color: $color-status-success !important;
}

.statusFail {
  color: $color-status-fail !important;
}

.propertyDetailsList {
  font-size: 13px;
}

.reasonStyle {
  // width: 500px;
  // margin-bottom: 20px;
  line-height: 1.5rem;
  word-wrap: break-word;
  white-space: normal;
}

.reportInfoHead,
.sideHeading {
  // letter-spacing: normal;
  // letter-spacing: 0.4em;
  // letter-spacing: 4px;
  // letter-spacing: 0.4px;
}
</style>

<style lang="scss">
.fraudPlusStatusModalHeader {
  padding-top: 24px;
  padding-bottom: 8px;
  border-bottom: 0 !important;
}

.fraudPlusStatusModalBody {
  border-bottom: 0 !important;
}

.fraudPlusStatusModalContent {
  padding-top: 24px;
  padding-bottom: 24px;
}

.fraudPlusStatusModalFooter {
  padding: 24px 0 !important;
}

.modalHeader.fraudPlusStatusModalTitle {
  padding-bottom: 0;
  font-family: Inter, Arial, sans-serif;
  font-size: 26px;
  font-weight: 700;
  line-height: 32px;
  color: #171a23;
}

.updateStatusModalLabel[class],
.updateStatusModalField label[class],
.addCommentModalField label[class] {
  margin: 0 0 4px;
  font-family: Inter, Arial, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #616975;
}

.updateStatusCommentGroup {
  margin-top: 30px;
}

.updateStatusModalField select,
.updateStatusModalField textarea,
.addCommentModalField textarea {
  font-family: Inter, Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: #171a23;
  background-color: #fff;
  border: 1px solid #616975;
  border-radius: 4px;
  outline: 0;
  box-shadow: none;
}

.updateStatusModalField textarea,
.addCommentModalField textarea {
  min-height: 60px;
  resize: vertical;
}

button.eBtn.fraudPlusStatusModalButton {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  height: 40px;
  min-height: 32px;
  max-height: 40px;
  padding: 0 24px;
  font-family: Inter, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700 !important;
  line-height: 16px;
  text-transform: uppercase;
  letter-spacing: 0.55px;
  vertical-align: middle;
  border-radius: 4px;
  outline: 0;
  transform: none;
}

button.eBtn.fraudPlusStatusModalButton.updateStatusModalCancelBtn,
button.eBtn.fraudPlusStatusModalButton.addCommentModalCancelBtn {
  color: #5c068c;
  background-color: #fff !important;
  border: 1px solid #5c068c;
}

button.eBtn.fraudPlusStatusModalButton.updateStatusModalPrimaryBtn,
button.eBtn.fraudPlusStatusModalButton.addCommentModalPrimaryBtn {
  color: #fff;
  background: linear-gradient(90deg, #5c068c 0%, #9840c7 100%) !important;
  border: 1px solid transparent;
}

button.eBtn.fraudPlusStatusModalButton.updateStatusModalCancelBtn:hover,
button.eBtn.fraudPlusStatusModalButton.updateStatusModalCancelBtn:focus,
button.eBtn.fraudPlusStatusModalButton.updateStatusModalCancelBtn:active,
button.eBtn.fraudPlusStatusModalButton.addCommentModalCancelBtn:hover,
button.eBtn.fraudPlusStatusModalButton.addCommentModalCancelBtn:focus,
button.eBtn.fraudPlusStatusModalButton.addCommentModalCancelBtn:active {
  color: #5c068c;
  background-color: #fff !important;
  border: 1px solid #5c068c;
}

button.eBtn.fraudPlusStatusModalButton.updateStatusModalPrimaryBtn:hover,
button.eBtn.fraudPlusStatusModalButton.updateStatusModalPrimaryBtn:focus,
button.eBtn.fraudPlusStatusModalButton.updateStatusModalPrimaryBtn:active,
button.eBtn.fraudPlusStatusModalButton.addCommentModalPrimaryBtn:hover,
button.eBtn.fraudPlusStatusModalButton.addCommentModalPrimaryBtn:focus,
button.eBtn.fraudPlusStatusModalButton.addCommentModalPrimaryBtn:active {
  color: #fff;
  background: linear-gradient(90deg, #5c068c 0%, #9840c7 100%) !important;
  border: 1px solid transparent;
}
</style>

<style lang="scss" scoped>
@import 'src/design/_redesign.scss';
/* stylelint-disable selector-pseudo-element-no-unknown,selector-class-pattern, property-no-unknown, no-descending-specificity */
/* stylelint-disable-next-line */
table>tbody>tr>td,
.noRecord,
.textSpacing {
  letter-spacing: normal;
  letter-spacing: 0.4em;
  letter-spacing: 4px;
  letter-spacing: 0.4px;
}

.loanBorder {
  border-left: 2px solid #c8ccd1 !important;
}

.loanData div {
  height: 24px;
  min-height: 24px;
  padding: 0 15px;

  /* letter-spacing: 1px; */
  border: 1px solid #dee2e6;
}

::v-deep .fraudReportHeaderTable>table>thead>tr>th>div {
  font-weight: 700;
  color: $color-raisin-100;
}

::v-deep .noRecord {
  border-radius: 4px;
}

.loanData div:nth-child(odd) {
  background-color: #f2f2f2;
}

.loanData div:nth-child(even) {
  background-color: #fff;
}

.loanInfoHeader {
  height: 43px;
  font-size: 0.8125rem;
  color: #fff;
  background-color: #a08bcb !important;
}

.labelContent {
  height: 45px !important;
  max-height: 45px;
  overflow-y: auto;
  letter-spacing: normal !important;
  vertical-align: middle !important;
}

.arrowSize {
  width: 30px;
  height: 30px;
}

.collapseStyle {
  background: linear-gradient(90deg, #5C068C 0%, #9840C7 100%) !important;
  border: none;
}

.collapseHeadStyle {
  background-color: $color-raisin-40 !important;
  border: none;
}

.collapseSubHeader {
  background-color: $color-raisin-40 !important;
  border: none;
}

.headerTextStyle {
  font-size: 14px;
}

.cautionSize {
  width: 25px;
}

.watchlistHeight {
  height: 30px;
}

::v-deep .table-bordered th,
.table-bordered td {
  border: 1px solid #c8ccd1;
}

::v-deep .table th {
  padding-right: 0.45rem;
  padding-left: 0.45rem;
}

::v-deep .loantableHead>table>thead>tr>th {
  color: #fff;
  background-color: transparent !important;
    border-color: transparent !important;
}

::v-deep .loantableHead>table>thead>tr {
  background: linear-gradient(90deg, #5C068C 0%, #9840C7 100%) !important;
}

::v-deep .loantableHead>table>thead {
  border-bottom: 0 !important;
}

::v-deep .fraudReportHeaderTable>table>thead {
  border-bottom: 0 !important;
}

::v-deep .fraudReportHeaderTable>table>thead>tr>th {
  background-color: #E9ECEF;
}

::v-deep .loantableHead table {
  overflow: hidden;
  border-spacing: 0;
  border-collapse: separate;
  border-radius: 4px;

  td {
    border-top-width: 0;
    border-right-width: 0;
  }

  td:first-child {
    border-left-width: 1px;
  }

  td:last-child {
    border-right-width: 1px;
  }
}

::v-deep .roundedReportTable {
  overflow: hidden;
  border-radius: 4px;
}

::v-deep .roundedReportTable table {
  overflow: hidden;
  border-spacing: 0;
  border-collapse: separate;
  border-radius: 4px;

  td {
    border-top-width: 0;
  }

  td:first-child {
    border-left-width: 1px;
  }

  tbody tr:first-child td {
    border-top-width: 1px;
  }

  tbody tr:first-child td:first-child {
    border-top-left-radius: 4px;
  }

  tbody tr:first-child td:last-child {
    border-top-right-radius: 4px;
  }

  tbody tr:last-child td:first-child {
    border-bottom-left-radius: 4px;
  }

  tbody tr:last-child td:last-child {
    border-bottom-right-radius: 4px;
  }
}

::v-deep .table-striped>tbody>tr:nth-child(even)>td {
  background-color: #F3F5F6 !important;
}

::v-deep .table-striped>tbody>tr:nth-child(odd)>td {
  background-color: #fff !important;
}

::v-deep table>tbody>tr>td:has(> [class*="statusFail"]) {
  padding: 0 !important;
}

::v-deep table>tbody>tr>td:has(> [class*="statusMedium"]) {
  padding: 0 !important;
}

::v-deep table>tbody>tr>td:has(> [class*="verifiedCell"]) {
  padding: 0 !important;
  white-space: nowrap !important;
}

.headerAlert {
  padding: 12px 16px;
  font-size: 13px;
  line-height: 20px;
  color: $color-dark-purple;
  background-image: linear-gradient(90deg, #5C068C 0%, #5C068C 48px, #FBF8FC 48px, #FBF8FC 100%);
  border: 1px solid $color-dark-purple;
}

.headerAlertText {
  padding-left: 32px;
}

.fraudReportLogoText {
  padding-left: 24px;
  font-size: 40.421px;
  font-weight: 900;
  line-height: 50.526px;
  color: $color-raisin-100;
}

a.fraudReportPrintLink {
  font-size: 13px;
  line-height: 20px;
  color: $color-dark-purple;
  text-decoration-line: underline;
}

.printReportLink {
  padding: 10px 12px 4px !important;
}

:global(.printReportCustom) {
  padding: 10px 12px 4px;
}

:global(.verifiedInfoHeader) {
  margin: -16px 0 0 0;
}

.headerXactusData {
  font-size: 18px;
  line-height: 20px;
  border-left: 1px solid #979797;
}

.verifiedCell {
  display: flex;
  width: 100%;
  padding: 2px 8px;
}

.verifiedCell.verifyStateN {
  font-weight: 700;
  color: $color-accent-red;
  background: $color-accent-error-30;
}

@media print {
  * {
    -webkit-print-color-adjust: exact !important;

    /* Chrome, Safari 6 – 15.3, Edge */
    color-adjust: exact !important;

    /* Firefox 48 – 96 */
    print-color-adjust: exact !important;

    /* Firefox 97+, Safari 15.4+ */
  }

  ::v-deep .table-bordered th,
  .table-bordered td {
    border: 1px solid #c8ccd1 !important;
  }

  ::v-deep .table th {
    padding-right: 0.45rem;
    padding-left: 0.45rem;
  }

  ::v-deep .table>thead>tr>th {
    background-color: #dbe7e9 !important;
  }
}

.watchlistActionsContainer {
  gap: 24px;
}

.watchlistAction {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  line-height: 20px;
  color: $color-raisin-100;
}

.roleTitleWatchlistTable {
  color: $color-raisin-70;
}

.watchlistTableWarningIconContainer {
  background-color: $color-accent-error-30;
}

.watchlistTableIconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.licenseVerificationsResultContainer {
  text-wrap: auto;
}

::v-deep .watchlistTable>table {
  overflow: hidden;
  border-spacing: 0;
  border-collapse: separate;
  border-radius: 4px;
}

::v-deep .watchlistTable>.table>thead>tr>th {
  padding: 8px;
}

::v-deep .watchlistTable>table>tbody>tr>td {
  height: 1px;
  padding: 0 !important;
}
</style>
